/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/anchor-is-valid */
import cx from "classnames";
import React, { Fragment, memo, useContext, useEffect, useState } from "react";

// Provider
import {
  AppContext,
  MAIN_MENU_SET,
  SET_DEVICE_BP_LIST,
  SET_DEVICE_BS_LIST,
  SocketCommand,
  socketManager,
} from "../components/AppProvider";
// Utils
import { _O } from "../modules/utils";

// Assets

// Env
import Swiper from "../modules/env/swiper-bundle.min.js";
// Temp Images
import _T_DEVICE_OMRON_IMAGE from "../resources/images/main/devicebuy_bloodpressure01.png";
import _T_DEVICE_INBODY_IMAGE from "../resources/images/main/devicebuy_bloodpressure02.png";
import _T_DEVICE_GLUENEO_IMAGE from "../resources/images/main/devicebuy_bloodsuger01.png";
import _T_DEVICE_ICON_TALK from "../resources/images/main/devicebuy_Icon_talk.png";
import _T_USER_DEFAULT_MALE from "../resources/images/user/photo_default_img.jpg";
import _T_USER_DEFAULT_FEMALE from "../resources/images/user/photo_default_img2.jpg";

import {
  AlertLogout,
  AlertWait,
  AutoLoginFailLayout,
  CnntFailLayout,
} from "../components/UI/Dialog";
import {
  PostApi1912,
  PostApi1960,
  PostApi1961,
  PostApiDvcList,
} from "../modules/network/padoPost";
import { checkNum10 } from "../modules/utils/CheckLogic";
import { getCookie, setCookie } from "../modules/utils/cookie";
import { IC } from "../resources/Assets";
import { LoadingLayer } from "./common/Layer/Loading";
import { CardEdit } from "./SelfManagement/SM.Layers";
import { request1914 } from "./Settings/Data";

import icon_modify_pen from "../resources/images/icon/icon_modify_pen.png";

// import { getCookie, setCookie } from "../../../modules/utils/cookie";
import dayjs from "dayjs";
import FloatButton from "../components/UI/Button/FloatButton.js";
import { NativeViewOpen } from "./common/NativeViewOpen/NativeViewOpen";

export const MenuNone = -1;
export const MainMenu = 0;
export const SubMenu = 1;

export const UserMenu = 10;
export const LogOutMenu = 11;
export const MyBoxMenu = 12;
export const CloseMenu = 13;
export const RightMenu = 14;

export default {
  // 공통
  MenuNone, // 메뉴 없음

  // 왼쪽 메뉴
  MainMenu, // 메인 메뉴(햄버거 메뉴)
  SubMenu, // 서브 메뉴(<- 표시)

  // 오른쪽 메뉴
  UserMenu, // 마이페이지
  LogOutMenu, // 로그아웃
  MyBoxMenu, // 수신함
  CloseMenu, // 화면종료
  RightMenu, // 오른쪽 메뉴 화면(약관보기 등)
};

export const MainContainer = (props) => {
  const { hospitals, reservations, Title, color, shareHspt, handleLogout, setLoginCnt } = props;
  const { auth, userinfo, mypagecfg } = useContext(AppContext);

  useEffect(() => {
    initLayout(auth);
    // }, []);
  }, [userinfo, mypagecfg.main, auth]);

  return (
    <div className="wrap">
      {/* <!-- 좌측 상단 삼선버튼(메뉴) --> */}
      <a className="btn-menulines">
        <span>
          <i></i>
          <i></i>
          <i></i>
        </span>
      </a>
      <div className="contents-container">
        <Header isMain Title={Title} container="container" shareHspt={shareHspt} />
        {props.children}
      </div>
      <BottomMenu
        color={color}
        floatButton={props.floatButton}
        floatButtonOption={{
          severity: props.floatButtonOption.severity,
          disable: props.floatButtonOption.disable,
          event: props.floatButtonOption.event,
          text: props.floatButtonOption.text,
        }}
      />
      <SideMenu handleLogout={handleLogout} />
      {/* <SelfLayer hospitals={hospitals} reservations={reservations} /> */}
      <CardEdit />
      <AlertWait />
      <AlertLogout />
      <CnntFailLayout />
      <AutoLoginFailLayout setLoginCnt={setLoginCnt} />
      {/* {!userinfo && <BottomLoginLayer />}
      <BottomLoginLayer /> */}
    </div>
  );
};

export const Container = memo((props) => {
  const {
    isMain,
    Title,
    bottom,
    children,
    dark,
    msgCount,
    goToUrl,
    container,
    setMode,
    proof,
    onClick,
    color,
    eventHandle,
    bizType,
    bizName,
    zIndex,
  } = props;
  const { auth, userinfo, mypagecfg } = useContext(AppContext);

  const handleMenuClick = () => {
    if (!isMain) {
      if (!goToUrl) {
        _O.goBack();
      } else {
        if (!setMode || setMode == "") {
          _O.Open(goToUrl);
        } else {
          setMode(0);
        }
      }
    }
  };

  useEffect(() => {
    initLayout(auth);
  }, [userinfo, mypagecfg.main]);

  return (
    <div className="wrap">
      {/* <!-- 좌측 상단 삼선버튼(메뉴) --> */}
      <a
        href={void 0}
        className={cx({ "btn-menulines": isMain, "btn-backpage": !isMain, dark: dark })}
        onClick={handleMenuClick}
      >
        <span>
          <i></i>
          <i></i>
          <i></i>
        </span>
      </a>
      <div className="contents-container" style={zIndex ? { zIndex: zIndex } : { zIndex: "0" }}>
        {/* <div className="contents-container"> */}
        <Header
          Title={Title}
          dark={dark}
          isMain={isMain}
          msgCount={msgCount}
          container={container}
        />

        {children}
      </div>
      {proof && proof != "" ? (
        <BottomMenu children={bottom} proof={proof} color={color}>
          <div className="under-fix-btnarea" style={{ borderBottom: "1px solid #fff" }}>
            {proof === "APPLY" && (
              <a className="agbtn" onClick={onClick}>
                <i></i>서류 발급 및 전송 약관동의
              </a>
            )}

            {proof === "PAYMENT" && (
              <a className="agbtn" onClick={onClick}>
                <i className="pay"></i>결제하기
              </a>
            )}

            {proof === "DOWNLOAD" && (
              <a className="agbtn" onClick={onClick}>
                <i className="down"></i>다운로드하기
              </a>
            )}

            {proof === "CLAIM" && (
              <a className="agbtn" onClick={onClick}>
                <i className="app"></i>확인
              </a>
            )}

            {proof === "PICBTN" && (
              <a className="picbtn" onClick={onClick}>
                <i className="app"></i>확인
              </a>
            )}

            {proof === "CONNECT_NOTHING" && (
              <a className="btn-connect" onClick={() => onClick("SET")}>
                <i></i>연결
              </a>
            )}

            {proof === "CONNECT_FAIL" && (
              <Fragment>
                <a className="btn-half-box set" onClick={() => onClick("SET")}>
                  <i></i>설정
                </a>
                <a className="btn-half-box relink" onClick={() => onClick("RE")}>
                  <i></i>재연결
                </a>
              </Fragment>
            )}

            {proof === "CONNECT_HSPT" && (
              <Fragment>
                <a className="halbtn" onClick={onClick}>
                  <i></i>추가
                </a>
              </Fragment>
            )}
          </div>
        </BottomMenu>
      ) : (
        <BottomMenu
          children={bottom}
          color={color}
          eventHandle={eventHandle}
          bizType={bizType}
          bizName={bizName}
        />
      )}
      <SideMenu />
      <AlertWait />
      <AlertLogout />
      <LoadingLayer />
      <CnntFailLayout />
      {/* confirm Layer 추가 */}
    </div>
  );
});

// leftMenu : 타이틀 왼쪽메뉴 설정(메인메뉴(햄버거메뉴), 서브메뉴(<-), 메뉴없음)
// rightMenu : 타이틀 오른쪽 메뉴(마이페이지, 로그아웃, 종료 등)
// gotoRightUrl : 오른쪽 메뉴 선택시 이동 URL
// gotoRightHandle : 오른쪽 메뉴 선택시 필요한 이벤트 처리(예: 로그아웃 팝업) handler
export const ContainerNew = (props) => {
  const {
    isMain,
    Title,
    bottom,
    children,
    dark,
    msgCount,
    goToUrl,
    container,
    leftMenu,
    rightMenu,
    gotoRightUrl,
    gotoRightHandle,
    signUpChannel,
    bottomHide,
  } = props;
  // 타이틀 왼쪽 메뉴 goto URL 설정
  const { auth, userinfo, mypagecfg } = useContext(AppContext);
  const handleLeftMenuClick = () => {
    if (leftMenu !== undefined && leftMenu !== MenuNone) {
      3;
      if (signUpChannel == "100" || signUpChannel == "400" || signUpChannel == "600") {
        _O.Open("/membership/login");
      } else {
        if (!goToUrl) {
          _O.goBack();
        } else {
          _O.Open(goToUrl);
        }
      }
    }
  };

  useEffect(() => {
    initLayout();
  }, [userinfo, mypagecfg.main]);

  return (
    <div className="wrap">
      {leftMenu !== undefined && leftMenu === MainMenu && (
        <a
          href={void 0}
          className={cx({
            "btn-menulines": true,
            "btn-backpage": false,
            dark: dark,
          })}
          onClick={handleLeftMenuClick}
        >
          <span>
            <i></i>
            <i></i>
            <i></i>
          </span>
        </a>
      )}
      {leftMenu !== undefined && leftMenu === SubMenu && (
        <a
          href={void 0}
          className={cx({
            "btn-menulines": false,
            "btn-backpage": true,
            dark: dark,
          })}
          onClick={handleLeftMenuClick}
        >
          <span>
            <i></i>
            <i></i>
            <i></i>
          </span>
        </a>
      )}

      <div className="contents-container">
        <HeaderNew
          Title={Title}
          dark={dark}
          isMain={isMain}
          msgCount={msgCount}
          container={container}
          leftMenu={leftMenu}
          rightMenu={rightMenu}
          gotoRightUrl={gotoRightUrl}
          gotoRightHandle={gotoRightHandle}
        />

        {children}
      </div>

      {/* 오른쪽 아이콘 */}
      {/* 오른쪽 메뉴 아이콘 CSS 설정이 wrap로 되어있어 여기에서 설정 */}
      {rightMenu === RightMenu && <a href={void 0} className="menuline-btn"></a>}

      {!bottomHide && <BottomMenu children={bottom} />}
      <SideMenu />
      <AlertWait />
      <AlertLogout />
      <CnntFailLayout />
    </div>
  );
};

export const ContainerNoBottom = (props) => {
  const {
    isMain,
    Title,
    bottom,
    children,
    dark,
    msgCount,
    goToUrl,
    container,
    leftMenu,
    rightMenu,
    gotoRightUrl,
    gotoRightHandle,
    signUpChannel,
  } = props;
  // 타이틀 왼쪽 메뉴 goto URL 설정
  const { auth, userinfo, mypagecfg } = useContext(AppContext);
  const handleLeftMenuClick = () => {
    if (leftMenu !== undefined && leftMenu !== MenuNone) {
      if (signUpChannel == "100" || signUpChannel == "400" || signUpChannel == "600") {
        _O.Open("/membership/login");
      } else {
        if (!goToUrl) {
          _O.goBack();
        } else {
          _O.Open(goToUrl);
        }
      }
    }
  };

  useEffect(() => {
    initLayout();
  }, [userinfo, mypagecfg.main]);

  return (
    <div className="wrap">
      {leftMenu !== undefined && leftMenu === MainMenu && (
        <a
          href={void 0}
          className={cx({
            "btn-menulines": true,
            "btn-backpage": false,
            dark: dark,
          })}
          onClick={handleLeftMenuClick}
        >
          <span>
            <i></i>
            <i></i>
            <i></i>
          </span>
        </a>
      )}
      {leftMenu !== undefined && leftMenu === SubMenu && (
        <a
          href={void 0}
          className={cx({
            "btn-menulines": false,
            "btn-backpage": true,
            dark: dark,
          })}
          onClick={handleLeftMenuClick}
        >
          <span>
            <i></i>
            <i></i>
            <i></i>
          </span>
        </a>
      )}

      <div className="contents-container">
        <HeaderNew
          Title={Title}
          dark={dark}
          isMain={isMain}
          msgCount={msgCount}
          container={container}
          leftMenu={leftMenu}
          rightMenu={rightMenu}
          gotoRightUrl={gotoRightUrl}
          gotoRightHandle={gotoRightHandle}
        />

        {children}
      </div>

      {/* 오른쪽 아이콘 */}
      {/* 오른쪽 메뉴 아이콘 CSS 설정이 wrap로 되어있어 여기에서 설정 */}
      {rightMenu === RightMenu && <a href={void 0} className="menuline-btn"></a>}

      <SideMenu />
      <AlertWait />
      <AlertLogout />
      <CnntFailLayout />
    </div>
  );
};

export const ContainerVideo = (props) => {
  const { children, backEvent } = props;

  return (
    <div className="wrap" style={{ maxWidth: "100%", backgroundColor: "#000" }}>
      {/* <a href={void 0} className={"btn-backpage"} onClick={() => _O.goBack()}> */}
      <a href={void 0} className={"btn-backpage"} onClick={backEvent}>
        <span>
          <i></i>
          <i></i>
          <i></i>
        </span>
      </a>

      <div className="contents-container">
        {/* header */}
        <div className={"header dark"} style={{ overflow: "hidden", backgroundColor: "#000" }}>
          {/* 왼쪽 메뉴는 퍼블로 인해 Header 밖에서 설정 */}

          {/* 타이틀 */}
          {/* <h1 style={{"padding":"0px 70px"}}>
                            <span>{Title}</span>
                    </h1> */}
        </div>
        {/* header */}
        {children}
      </div>
    </div>
  );
};

// intro용 컨테이너
export const IntroContainer = (props) => {
  const { children, color, url, returnUrl, btnText } = props;

  useEffect(() => {
    if (!btnText) {
      $(".ppm-slide").slick({
        arrows: false,
        dots: true,
        infinite: false,
      });
    }
  }, []);

  return (
    <div>
      <a
        onClick={() => _O.Open(returnUrl ? returnUrl : "/proof/apply")}
        className="btn-closex-white"
      ></a>
      <div
        className={!color ? "purple-main-contain" : "purple-main-contain green"}
        style={color ? { backgroundSize: "100% 22vh" } : {}}
      >
        <div className="ppm-slide" style={props.ppmHeight ? { height: props.ppmHeight } : null}>
          {children}
        </div>

        <div className="bottom-box" style={props.ppmHeight ? { height: "auto" } : null}>
          <a
            onClick={() => _O.Open(url)}
            style={props.ppmHeight ? { top: "auto", transform: "none" } : null}
          >
            {btnText ? btnText : "제증명서류 발급"}
          </a>
          {!!props.ppmMargin && <div style={{ height: props.ppmMargin }}></div>}
        </div>
      </div>
    </div>
  );
};

export const Header = memo((props) => {
  const { Title, dark, isMain, msgCount, container, shareHspt } = props;
  const { auth, userinfo } = useContext(AppContext);
  const [showCnntHspt, setShowCnntHspt] = useState(true);
  // let type = (!auth && !isLogin())?"btn-user":shareHspt==='Y'?"btn-user-check_pink":"btn-user-check";
  let type = "btn-user";
  // let url =  (auth)?"#/mp" :"#/membership/login";
  // let url = auth ? "#/" : "#/";
  let url = auth ? "#/cnntHspt/1" : "#/";
  let checkType = "hospital_check";

  if (shareHspt === "Y") {
    checkType = "hospital_check_on";
  }

  const goCnntHspt = () => {
    if (shareHspt === "Y") {
      _O.Open("/mp/settings/data");
    } else {
      _O.Open("/cnntHspt/1");
    }
  };

  useEffect(() => {
    if (userinfo.app && userinfo.app.sharHsptList) {
      if (userinfo.app.sharHsptList.length > 0) {
        setTimeout(() => {
          setShowCnntHspt(false);
          setCookie("showCnntHspt", true, -1);
        }, [30000]);
      }
    }
  }, [userinfo.app]);

  return (
    <div className={cx({ header: true, dark: dark })}>
      <h1>
        {!isMain ? (
          <span>{Title}</span>
        ) : (
          <a>
            {/* <span className="logo">{Title}</span> */}
            <img
              src={IC.etc.title}
              style={{
                width: "8rem",
                margin: "14.23px",
              }}
            />
          </a>
        )}
      </h1>

      {!dark && container === "container" && (
        <a
          href={url}
          className={type}
          style={{ opacity: userinfo.app && userinfo.app.sharHsptList.length > 0 ? "1" : "0.5" }}
        >
          {msgCount > 0 && <i>{msgCount}</i>}
        </a>
      )}

      {shareHspt &&
        userinfo.app &&
        // <i className={checkType} onClick={() => goCnntHspt()}></i>
        getCookie("showCnntHspt") == undefined && <CnntHsptView />}
    </div>
  );
});

const CnntHsptView = () => {
  const { userinfo } = useContext(AppContext);
  const [listSharY, setListSharY] = useState([]);
  const style = {
    backgroundColor: "#000",
    opacity: "0.7",
    color: "#fff",
    textAlign: "center",
    borderRadius: "4px",
    position: "relative",
    top: "-46px",
    float: "right",
    marginRight: "20px",
    padding: "4px 8px",
    display: "flex",
  };

  const imgStyle = {
    width: "16px",
    height: "16px",
    display: "block",
    margin: "auto",
    marginLeft: "8px",
  };

  useEffect(() => {
    setListSharY(userinfo.app.sharHsptList.filter((m) => m.sharYn === "Y"));
  }, [userinfo]);

  return (
    <div
      style={style}
      onClick={() => _O.Open(listSharY.length > 0 ? "/cnntHspt/0" : "/cnntHspt/1")}
    >
      {listSharY.length > 0 ? (
        listSharY.length > 1 ? (
          listSharY[0].hsptNm +
          "(" +
          listSharY[0].address2 +
          ") 외 " +
          (listSharY.length - 1) +
          "건"
        ) : (
          listSharY[0].hsptNm + "(" + listSharY[0].address2 + ")"
        )
      ) : (
        <>
          연결된 병원이 없습니다. <img src={icon_modify_pen} style={imgStyle} />
        </>
      )}
    </div>
  );
};

export const HeaderNew = (props) => {
  const {
    isMain,
    Title,
    dark,
    msgCount,
    container,
    leftMenu,
    rightMenu,
    gotoRightUrl,
    gotoRightHandle,
  } = props;

  let type = "";
  let rightUrl = "";

  if (rightMenu === undefined) {
  } else if (rightMenu === MyBoxMenu) {
    type = "btn-mybox";
    rightUrl = "/#/pmr/recentFileList";
  } else {
    if (rightMenu === UserMenu) {
      type = "btn-user";
    } else if (rightMenu === CloseMenu) {
      type = "btn-close-blk";
    } else if (rightMenu === LogOutMenu) {
      type = "btn-logout";
    } else if (rightMenu === RightMenu) {
      type = "menuline-btn";
    } else {
      type = "";
    }

    rightUrl = gotoRightUrl === undefined || type.length === 0 ? "" : gotoRightUrl;
  }

  const handleRightMenuClick = () => {
    if (gotoRightHandle === undefined) {
      if (rightUrl.length === 0) {
        _O.goBack();
      } else {
        _O.Open(rightUrl);
      }
    } else {
      gotoRightHandle();
    }
  };

  return (
    <div className={cx({ header: true, dark: dark })} style={{ overflow: "hidden" }}>
      {/* 왼쪽 메뉴는 퍼블로 인해 Header 밖에서 설정 */}

      {/* 타이틀 */}
      <h1 style={{ padding: "0px 70px" }}>
        {isMain ? (
          <a>
            <img
              src={IC.etc.ICTitleColor}
              style={{
                width: "8rem",
                margin: "14.23px",
              }}
            />
          </a>
        ) : leftMenu !== MainMenu ? (
          <span>{Title}</span>
        ) : (
          <a href={void 0}>
            <span className="logo">{Title}</span>
          </a>
        )}
      </h1>

      {/* 오른쪽 아이콘 */}
      {/* 오른쪽 메뉴 아이콘을 제외한 다른 아이콘은 CSS 설정이 header로 되어있어 여기에서 설정 */}
      {rightMenu !== undefined && rightMenu !== MenuNone && rightMenu !== RightMenu && (
        <a href={void 0} className={type} onClick={handleRightMenuClick}>
          {msgCount > 0 && <i>{msgCount}</i>}
        </a>
      )}
    </div>
  );
};

export const BottomMenu = (props) => {
  const { hash } = window.location;
  const [h, setH] = useState("");
  const { auth, userinfo, cfg } = useContext(AppContext);
  const { eventHandle, bizType, bizName } = props;

  const unCheckedAll = () => {
    $("input:checkbox").prop("checked", false);
  };
  const onClickMenu = (url) => {
    if (url.length > 0) {
      if (!auth) {
        _O.OpenMenu("/membership/login");
      } else {
        _O.OpenMenu(url);
      }
    } else {
      // alert("서비스 오픈 예정입니다.");
      openLayerFn($(".alert-layer2"));
    }
  };

  const callUploadWs = () => {
    let targetArr = [];
    let targetArr2 = [];
    let sendParam = {};

    let masterKey1 = "";
    let masterKey2 = "";

    // {masterkey1:"", masterkey2:""}
    $('input:checkbox[name="targetCheck"]').each(function () {
      if (this.checked) {
        masterKey1 = this.value.split("!")[0];

        if (this.value.split("!")[1]) {
          masterKey2 = this.value.split("!")[1];
        }

        targetArr.push({
          masterKey1: masterKey1,
          masterKey2: masterKey2,
          masterKey3: "",
        });
      }
    });

    if (bizName) {
      sendParam = {
        type: "upload",
        userToken: userinfo.userToken.toString(),
        masterKeys: targetArr,
        bizType: bizType,
        bizName: bizName,
        bizDtlType: "1",
        viewYN: "N",
        saveExtYN: "N",
        redirectURL: "cnntHspt/1",
        colorType: "PP",
        hsptSharYn: "N",
      };
    } else {
      sendParam = {
        type: "upload",
        userToken: userinfo.userToken.toString(),
        masterKeys: targetArr,
        bizType: "PR",
        bizName: "개인진료기록",
        bizDtlType: "1",
        viewYN: "N",
        saveExtYN: "N",
        redirectURL: "cnntHspt/1",
        colorType: "PP",
        hsptSharYn: "N",
      };
    }

    socketManager(SocketCommand.FILE_UPLOAD, eventHandle, sendParam);
  };

  useEffect(() => {
    setH(hash.replace("#", ""));
  }, [hash]);

  return (
    <div className="fix-area">
      {props.proof && <div className="under-fixarea-emptybox"></div>}
      <div>
        {props.children}

        <div className="under-fix-btnarea" id="confirmCheck" style={{ display: "none" }}>
          <a className="btn-full-box share" onClick={() => callUploadWs()}>
            <i></i>공유병원 선택하기
          </a>
        </div>

        <div className="under-fix-btnarea" id="inputOk" style={{ display: "none" }}>
          <a className="btn-inputok-lb">
            <i></i>확인
          </a>
        </div>

        {props.floatButton === true && (
          <div style={{ width: "100%" }}>
            <FloatButton
              severity={props.floatButtonOption.severity}
              disable={props.floatButtonOption.disable}
              event={props.floatButtonOption.event}
              text={props.floatButtonOption.text}
              bottomMenu={true}
            />
          </div>
        )}

        {/* 하단 메뉴 */}
        <div
          className={
            !props.color
              ? "bottom-menu"
              : props.color == "green"
              ? "bottom-menu-green"
              : "bottom-menu-purple"
          }
        >
          {/* <div className="bottom-menu"> */}
          <div className="menu-list">
            <ul>
              <li style={{ width: "25%" }}>
                <a
                  href={void 0}
                  className={cx({ m1: true, on: h === "/" })}
                  onClick={(e) => _O.OpenMenu("/")}
                >
                  <em>
                    <i></i>
                  </em>
                  <p>홈</p>
                </a>
              </li>
              <li style={{ width: "25%" }}>
                <a
                  className={cx({ m3: true, on: h.startsWith("/pmr") })}
                  onClick={(e) => onClickMenu("/pmr/treatmentData")}
                >
                  <em>
                    <i></i>
                  </em>
                  <p>개인진료기록</p>
                </a>
              </li>
              <li style={{ width: "25%" }}>
                <a
                  className={cx({ m4: true, on: h.startsWith("/sm") })}
                  onClick={() => onClickMenu("/sm")}
                >
                  <em>
                    <i></i>
                  </em>
                  <p>자가건강관리</p>
                </a>
              </li>
              <li style={{ width: "25%" }}>
                <a className={cx({ m5: true, on: false })} onClick={() => onClickMenu("/mp")}>
                  <em>
                    <i></i>
                  </em>
                  <p>마이페이지</p>
                </a>
              </li>

              {/* <li onClick={(e) => _O.OpenMenu("/")}>
                                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0">
                                    <image className={cx({ m1: true, on: h === "/" })} id="icons8-home-50" width="24" height="24" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAABU0lEQVRoge2ZMUoDQRiFPzWpQ7AQbbXQUm09gFp5HD2DeACvYCeiN7AOpPACURQhgrYxaLEbMJNZM+Nmdh74f/CKbELyvn1bTcAwjH/BUuLvPgB2ytcPwD3wlfA3F84x0Kco/TP98j15OsAlswJuroDVTB3ncggMmC8xyTNwkqVpBaErSK8Tu4LcOnVXkFhnUStkWyfVCo2uc0TaFZKv0/QKSdbZBx4FJCYZAHuxElvAh0B5N+/AZozInUDpqtyGSqwDY4HCVfkE1tzSyx6R7YrrKqxQdJzCV7iTvkttuu4F5TsfhYmoYSJqmIgaJqKGiahhImqYiBomooZPZNx4i3hmOvpEXhsoUpeXkA+1gTfyn5ZUZVh2nMK3yAi4CDHOxDlFxyBawA35776ba4rjoChawBkaj9kQOP1NIuR/9jawC2zgeTYTMwKegB7FCaNhGH/kG0kT3aSQcw40AAAAAElFTkSuQmCC"/>
                                </svg>
                                <p style={{fontSize:"10px"}}>홈</p>
                            </li>

                            <li style={{width:"25%"}}>
                                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0">
                                    <image className={cx({ m3: true, on: h.startsWith("/pmr") })} id="icons8-list-48" width="24" height="24" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAACEklEQVRoge2ZP0vDQBiHn4qKg1IKWgfBP7NS8DN0dFSEIo76LQQXZ0e1WBelg4hudtG5m4vuVcRBXCri0ArW4a6Qptfm7tpcWswDR9o0efP75S739t5ATMz/JqF5XArIAvPAWHhyAKgDr8AdUO01WBrIy6ANx60OHAMztuKXgZcIhPvbs9RiRHpAxHtNGPVEfgBE+9uRrvgU0Yz5oFYDkn6xIwoDWcKfaWwYR2hrQWVgMXwt1iz5d4wqDpoMCPILFIG3fijyMAds0T03Tfl3qAwEUQS2Lc7TIYEwoY1qCA0VNj3Q7ObHPmvJADnTk2wMGHdzmAz9EIoNRI3NMxBlHmgjzgNRE+eBqPmXQygMKkAZeEcsplRMIJaWLURpoAHcAAfAg20Ql3nAO89/Ih7YkvxNp+5UAS51LrRP97XpuaFwLxeIYtWK/G5ad9rwB4xiCOWAJ0St5xZx13Vp+He4zAMZxMK8hLjzpuILwLXOgUFDqJe2Kq9hWncqYDDlh2WgIuOb1p1Ou4l3mcjKcmtSdyoAu4iZT4lLA81pV7fudEaAeFAb+DIQZcK33AbVnUCI3yFAPKgNtKVrx2iLB7WBe+Cnn4oMMBIPagNVGcg1xuKh80O8h3jB4Qor8dDZwAewhhsT1uJ1mEa8GanReyI7lDE30UxSOuiWMJKIBLQAzFpeqwKcyM/rCOFXKP6gxcTE6PMHjFtmVue9Mg8AAAAASUVORK5CYII="/>
                                </svg>
                                <p style={{fontSize:"10px"}}>병원기록</p>
                            </li>

                            <li style={{width:"25%"}}>
                                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0">
                                    <image className={cx({ m4: true, on: h.startsWith("/sm") })} id="icons8-list-48" width="24" height="24" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAB1klEQVRoge2Zy0rDQABFT1vBrS/8AQWxKIpL8TO0oBtXLvQz+gfdqBtREBQEd9Z/UEQK4s6tO5VulFZtdDEZiCGTx+Qxo+bAhfQxk3NDk0wolJT8byoaY0aBRWAKGAd6QBe4Be4BJ2J8DagDS+5cw8Az8AB03LkypwI0gEugD3wp0gX2gLmAOeaBffc7qvF9oA2soXdwA1kBbkJ2qsohMII4ykca46+B5bTyO8CHxs5lHt3ojn8HtnXlmyl2nHWaSeVXESejaXEZB9iIKz8NvFkg7c8r4soXyYkFsqocR8nXgYEFoqoMgFmvcNVXoBHwnk1UEfcIJTrX+6Jz5RX23u1qiDthLfbxMMMnYvnhwM+fyyT2ywMMARPyhbfAWPEu2gQWeDEgosuT3PhT58AAuDNhlJAOnmcO/zX/olgXLdphHy5g1yLOHwfxYBTKuQWiqpxFyYNYa4Q9NppKD5iJUwBg0wJhf7biyktaFkjLtJLKg7hH7Fogf0CKFbLpEqnkTZfIRN5UiUzliy6Ri3xRJXKVz7tEIfJ5lShUXpJVCSPykrQljMpLdEtYIS9JWsIqeUncElbKS6JKWC0vUZX4FfISf4nc5DP7J1Ax97q7fYooUlJSkjHfXF8t9Kx/ZuoAAAAASUVORK5CYII="/>
                                </svg>
                                <p style={{fontSize:"10px"}}>건강관리</p>
                            </li>

                            <li style={{width:"25%"}}>
                                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0">
                                    <image className={cx({ m5: true, on: h.startsWith("/mp") })} id="icons8-list-48" width="24" height="24" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAABzElEQVRoge2YT0rDQBxGX9UqiooLwTN4CqkUFASLUqVewBtIQVRcte68RE/jUhdqUVu9gH/qsrQuMoUkJLaT32QSZR58UNLO5H0taWYCDsefoQhUgRZwD3wDPfW6pd4rZmY3IRWgDQzHpK0+mzumgCbjC/gzABpqbG7QLeFPIwPfSCp4327SIgNg17p1iCKTXRPj8gzMWnYPUI2QSpqqRER6oe0Jx/vJ9F/sEXO/yINl9wC9GKkk6UlECpLBSsAkiX1ydTOS4IrkDVckb0iLfBqxMDCXtMibcLyfV8lgaZFb4fi05tJmB3N39m3L7gFmgE6ElG6e1FyZsol8Y1W2bh3DNcmLNDPw/ZVL9EtcmTq5dPUbRnc1bOz87s6eN1yRCNYSjFk1eH4xBbynKS/o/2vdASX7ykGmgRreGkl6Z78BDtWc1lgEjjH7KGiUDlAHVtIssABcAB8pFAjnHTgD5k2XKOHtPdIuEE4X2DBVog70MygxSh84kZY4z7BAOKdJS5SRLc9NZwBs6ZaYw9tDZy0fTle5TcxBDqTjsh8lHLdEqem0tsxR1MG4IuspikiJdIvb2HwBS+m5iOgBy+GDcUWG6bqIMb2zdTj+PT8R1wlhLnikZwAAAABJRU5ErkJggg=="/>
                                </svg>
                                <p style={{fontSize:"10px"}}>마이페이지</p>
                            </li> */}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

const _SIDEMENU = [
  { label: "HOME", url: "/", classname: "ci1", ret: 0 },
  { label: "병원예약", url: "/surround", classname: "ci2", ret: 5 },
  // { label: "예진/문진", url: "/question", classname: "ci3", ret: 0 },
  { label: "처방전", url: "/eocs", classname: "ci4", ret: 4 },
  // { label: "제증명서류/보험청구", url: "", classname : "ci5",ret : -1 },
  // { label: "결제", url: "" , classname : "ci6" ,ret : -1},
  // { label: "검사스케쥴", url: "" , classname : "ci7" ,ret : -1},
  { label: "자가건강관리", url: "/sm", classname: "ci8", ret: 1 },
  { label: "개인진료기록", url: "/pmr/treatmentData", classname: "ci9", ret: 1 },
  // { label: "전화예약진료", url: "", classname : "ci10",ret : -1 },
  // { label: "복약관리", url: "", classname : "ci11" ,ret : -1},
  // { label: "나의스케줄", url: "", classname : "ci12" ,ret : -1},
  { label: "설정", url: "/mp/settings/1", classname: "ci13", ret: 0 },
  // { label: "About Us", url: "/mp/aboutUs", classname : "ci14" ,ret : -1},
  { label: "Log In", url: "/membership/login", classname: "ci15", ret: 9 },
];

export const SideMenu = (props) => {
  const { userinfo, auth } = useContext(AppContext);
  const { handleLogout } = props;
  const onClickMenu = (url, ret) => {
    if (url.length > 0) {
      if (!auth) {
        _O.OpenMenu("/membership/login/" + ret);
      } else {
        if (ret === 9) {
          // handleLogout();
          handleLogout(true);
        } else {
          _O.OpenMenu(url);
        }
      }
    } else {
      openLayerFn($("#alert-layer2"));
    }
  };

  return (
    <div className="side-menu-container">
      <div>
        <div className="smc-blind"></div>
        <a href={void 0} className=""></a>
        <div className="in-menu-area">
          <div>
            <div className="top-area">
              {auth ? (
                <Fragment>
                  <div>
                    <div className="photo">
                      {auth && userinfo.sex === "1" && <img src={_T_USER_DEFAULT_MALE} alt="" />}
                      {auth && userinfo.sex === "2" && <img src={_T_USER_DEFAULT_FEMALE} alt="" />}
                    </div>
                    <div>
                      <span>{auth && userinfo.userName}</span>
                      <p>{auth && userinfo.userPhone}</p>
                    </div>
                  </div>
                  <a onClick={() => _O.OpenMenu("/noticeBoard")} className="btn-bell">
                    <u></u> {/*<!-- 빨간 점 -->*/}
                  </a>
                </Fragment>
              ) : (
                <Fragment></Fragment>
              )}
            </div>
            <div className="mlist">
              <ul>
                {_SIDEMENU.map((menu, i) => (
                  <li key={i}>
                    <a onClick={() => onClickMenu(menu.url, menu.ret)}>
                      <i className={menu.classname}></i>
                      {auth && menu.label === "Log In" ? "Log Out" : menu.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const SelfLayer = (props) => {
  const { hospitals, reservations } = props;
  const { auth, userinfo, cfg, mypagecfg, phonecfg, dispatch } = useContext(AppContext);
  const request1912 = (userinfo, cfg, cardType, cardId, useYn) => {
    PostApi1912(userinfo, cfg, phonecfg, cardType, cardId, useYn)
      .then((res) => {
        if (res.resultMsg === "SUCCESS") {
          // 저장 후 팝업 닫고 하단 페이지  새로고침
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const saveMainCardMgmt = () => {
    let screen = [];
    let status = [];
    $("input[type=checkbox]").each(function () {
      screen.push(this.id);
      status.push(this.checked ? "Y" : "N");
    });
    dispatch({ type: MAIN_MENU_SET, screen: screen, status: status });
    request1912(userinfo, cfg, "main", screen, status);
    // 페이지 닫기
    closeLayerFn($(".myhealth-manage-layer"));
  };

  return (
    <div className="blacklayer-container myhealth-manage-layer">
      <div className="bl-blind"></div>
      <div className="in-layerarea">
        <a href={void 0} className="btn-setlayer-close"></a>
        <div>
          <div className="my-section">
            <div className="check-area">
              <label>
                <input type="checkbox" className="mym-check1" id="myHospitalList" name="viewYn" />
                <i></i>
              </label>
            </div>
            <div className="inbox">
              <div className="my-hospital-list treat">
                <div className="main-section-title">MY 진료기록</div>
                <div className="treat-list">
                  <ul>
                    {hospitals?.map((item, i) => {
                      const date = dayjs(item.date, "YYYYMMDDHHmmss");
                      return (
                        <li key={i} className={cx({ [item.color]: true })}>
                          <div className="date-time">
                            <span>
                              <u>{date.format("MM-DD")}</u>
                              <br />
                              {date.format("a")} <em>{date.format("h:mm")}</em>
                            </span>
                          </div>
                          <div className="treat-info">
                            <div className="in-infobox">
                              <div className="rbox">
                                <div>
                                  <div className={cx({ photo: true, [item.icon]: true })}></div>
                                  <div className="hosinfo">
                                    <span>{item.type}</span>
                                    <p>{item.hospital}</p>
                                    <em>{item.doctor}</em>
                                  </div>
                                  <a
                                    className="inbtn btn-checkround"
                                    onClick={(e) => _O.Open(item.url)}
                                  ></a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                {/* <div className="empty-box">
                                <a href={void 0}>
                                    <i></i>
                                    <p>진료기록 서비스 이용하기</p>
                                </a>
                            </div> */}
              </div>
            </div>
          </div>
          <div className="my-section">
            <div className="check-area">
              <label>
                <input type="checkbox" className="mym-check2" name="viewYn" id="BloodPressure" />
                <i></i>
              </label>
            </div>
            <div className="inbox">
              <div className="my-blood-pressure">
                <div className="main-section-title">MY 자가건강관리</div>
                <div className="graph-box" style={{ display: "none" }}>
                  {/* 그래프 연동 : 높이 300 */}
                </div>
                {/* <div className="empty-box">
                                <a href={void 0}>
                                    <i></i>
                                    <p>자가건강관리 서비스 이용하기</p>
                                </a>
                            </div> */}
              </div>
            </div>
          </div>
          <div className="my-section">
            <div className="check-area">
              <label>
                <input type="checkbox" className="mym-check3" name="viewYn" id="ReservationList" />
                <i></i>
              </label>
            </div>
            <div className="inbox">
              <div className="my-hospital-list">
                <div className="main-section-title">MY 병원예약(임의예약/확정예약)</div>
                <div className="treat-list">
                  <ul>
                    {reservations?.map((item, i) => {
                      const date = dayjs(item.date, "YYYYMMDDHHmmss");
                      return (
                        <li key={i} className={cx({ [item.color]: true })}>
                          <div className="date-time">
                            <span>
                              <u>{date.format("MM-DD")}</u>
                              <br />
                              {date.format("a")} <em>{date.format("h:mm")}</em>
                            </span>
                          </div>
                          <div className="treat-info">
                            <div className="in-infobox">
                              <div className="rbox">
                                <div>
                                  <div className="photo">
                                    <img src={item.icon} alt="" />
                                  </div>
                                  <div className="hosinfo">
                                    <span>{item.hospital}</span>
                                    <p>{item.doctor}</p>
                                    <em className={cx({ on: item.isOn })}>{item.type}</em>
                                  </div>
                                  <a
                                    className="inbtn btn-location"
                                    onClick={(e) => _O.Open(item.url)}
                                  ></a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>

                {/* <div className="empty-box">
                                <a href={void 0}>
                                    <i></i>
                                    <p>병원예약 서비스 이용하기</p>
                                </a>
                            </div> */}
              </div>
            </div>
          </div>
        </div>

        <div className="btn-list-save">
          <a onClick={saveMainCardMgmt}>목록 저장</a>
        </div>
      </div>
    </div>
  );
};
//세팅 변수
let checkCrInNum;

let pickslideYear;
let pickslideMonth;
let pickslideDay;
let pickslideDate;
let pickslideAmpm;
let pickslideHour;
let pickslideMinute;
let yearInvalue;
let monthInvalue;
let dayInvalue;

let dateInvalue;
let ampmInvalue;
let hourInvalue;
let minuteInvalue;

let lastDate;
let keyInvalue;
let inptHourInvalue;
let inptMinInvalue;
let inptTimeInvalue;

export const SettingYear = (props) => {
  const { year } = props;

  return year.map((m, i) => (
    <div className="swiper-slide" key={i}>
      <span>{m}년</span>
    </div>
  ));
};

export const SettingMonth = (props) => {
  const { type, month } = props;

  useEffect(() => {
    if (pickslideMonth != null && pickslideMonth != "") {
      pickslideMonth.update();
    }
    // });
  }, [month]);

  return month.map((m, i) => (
    <div className="swiper-slide" key={i}>
      <span>{m}월</span>
    </div>
  ));
};

export const SettingDate = (props) => {
  const { type, date, toYear, toMonth } = props;

  useEffect(() => {
    if (pickslideDay != null && pickslideDay != "") {
      pickslideDay.update();
    }
  });

  return date.map((m, i) => (
    <div className="swiper-slide" key={i}>
      <span name={m}>{m}일</span>
    </div>
  ));
};

export const DateLayer = (props) => {
  const { handleDate, color, id, setCalendar } = props;

  let toDay = new Date();

  let toMonthData = toDay.getMonth() + 1;

  if (toMonthData < 10) {
    toMonthData = "0" + toMonthData.toString();
  }

  const [toYear, setToYear] = useState(toDay.getFullYear().toString());
  const [toMonth, setToMonth] = useState(toMonthData);
  const [toDate, setToDate] = useState(toDay.getDate());

  const [oriYear, setOriYear] = useState(toDay.getFullYear().toString());
  const [oriMonth, setOriMonth] = useState(toMonthData);
  const [oriDate, setOriDate] = useState(toDay.getDate());

  // setState를 위한 배열
  let yearArr = [];
  let monthArr = [];
  let dateArr = [];

  // .map을 위한 배열 State
  const [year, setYear] = useState([]);
  const [month, setMonth] = useState([]);
  const [date, setDate] = useState([]);

  const settingYear = () => {
    // 오늘 년도-2 ~ 오늘 년도
    // for (let i = toYear - 2; i <= toYear; i++) {
    //   yearArr.push(i);
    // }

    const fromYear = toYear - 10;

    for (let i = fromYear; i <= toYear; i++) {
      yearArr.push(i);
    }
    setYear(yearArr);
  };

  const settingMonth = () => {
    // 1월~12월
    let endMonth = 12;
    if (toDay.getFullYear().toString() === toYear) {
      endMonth = parseInt(toMonthData);
    }

    for (let i = 1; i <= endMonth; i++) {
      if (i < 10) {
        monthArr.push("0" + i);
      } else {
        monthArr.push(i);
      }
    }
    setMonth(monthArr);
    setOriMonth(endMonth);
  };

  const settingDate = () => {
    // 1일~최대일
    for (let i = 1; i <= lastDate; i++) {
      if (i < 10) {
        dateArr.push("0" + i);
      } else {
        dateArr.push(i);
      }
    }
    setDate(dateArr);
  };

  const settingLastDate = (toYear, toMonth) => {
    if (toYear === toDay.getFullYear().toString() && toMonth == toMonthData) {
      lastDate = toDay.getDate(0);
    } else {
      lastDate = new Date(toYear, toMonth, 0).getDate();
    }
    settingDate();
  };

  useEffect(() => {
    //열기
    $(".date-picker-input").off("click");
    $(".date-input-layer .tbns-area a").off("click");

    $(".date-picker-input").click(function () {
      pickerEndFn();
      // inputBox가 값이 있으면 해당 값 기본값으로 open
      // inputBox에 값이 없으면 오늘 날짜 기본값으로
      checkCrInNum = $(this).data("num");
      openLayerFn($(".date-input-layer"));

      // from, to 구분부터 checkCrInNum (1:from 2:to)
      // 2000 ~ 2023
      if (checkCrInNum == "1") {
        if ($(".pick-num1").val() != "") {
          pickerStart(
            setToYear,
            setToMonth,
            // toYear - $(".pick-num1").val().split(".")[0],
            $(".pick-num1").val().split(".")[0],
            $(".pick-num1").val().split(".")[1],
            $(".pick-num1").val().split(".")[2],
            setToDate
          );
        } else {
          pickerStart(setToYear, setToMonth, 0, toDay.getMonth() + 1, oriDate, setToDate);
        }
      } else {
        if ($(".pick-num2").val() != "") {
          pickerStart(
            setToYear,
            setToMonth,
            // toYear - $(".pick-num2").val().split(".")[0],
            $(".pick-num2").val().split(".")[0],
            $(".pick-num2").val().split(".")[1],
            $(".pick-num2").val().split(".")[2],
            setToDate
          );
        } else {
          // pickerStart(setToYear, setToMonth, 0, oriMonth, oriDate);
          pickerStart(setToYear, setToMonth, 0, toDay.getMonth() + 1, oriDate, setToDate);
        }
      }
    });

    //닫기
    $(".date-input-layer .tbns-area a").click(function () {
      //확인버튼일 경우 선택값 적용
      // 검색 범위 체크로직 추가
      if ($(this).hasClass("wht")) {
      }
      pickerEndFn();
      closeLayerFn($(".date-input-layer"));
    });
    // },[]);
  }, [toYear, toMonth, toDate, month]);

  const checkSrchRnge = (from, to) => {
    // from과 to의 범위는 최대 5년
    if (from != "" && to != "") {
      if (parseInt(to.substring(0, 4)) - parseInt(from.substring(0, 4)) <= 5) {
        return true;
      } else {
        // 범위 넘어감 표시
        return false;
      }
    }
  };

  const setDateLayer = () => {
    dayInvalue = $(".pickslide-day .swiper-slide-active span").html();
    var totalValue =
      // yearInvalue.slice(0, -1) + "." + monthInvalue.slice(0, -1) + "." + dayInvalue.slice(0, -1);
      yearInvalue.slice(0, -1) + "." + checkNum10(toMonth) + "." + checkNum10(toDate);
    const dateValue =
      // yearInvalue.slice(0, -1) + monthInvalue.slice(0, -1) + dayInvalue.slice(0, -1);
      yearInvalue.slice(0, -1) + checkNum10(toMonth) + checkNum10(toDate);

    if (checkCrInNum == "1") {
      $(".pick-num1").val(totalValue);
      if (handleDate != null) handleDate("1", dateValue);
    } else if (checkCrInNum == "2") {
      $(".pick-num2").val(totalValue);
      if (handleDate != null) handleDate("2", dateValue);
    }

    if (setCalendar) {
      setCalendar(false);
    }
  };

  useEffect(() => {
    settingYear();
  }, []);

  useEffect(() => {
    settingMonth();
  }, [toYear]);

  useEffect(() => {
    // test
    settingLastDate(toYear, toMonth);
  }, [toYear, toMonth]);

  return (
    <div className="blacklayer-container date-input-layer" id={"dateLayer" + id}>
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div className={color === "green" ? "blgrn-box vertical" : "blgrn-box vertical priv"}>
          <div className="blgr-title">일시 설정</div>

          <div className="picker-container w3">
            <div className="swiper-container pickslide-year">
              <div className="swiper-wrapper">
                {year != [] && year.length > 0 && <SettingYear year={year} />}
              </div>
            </div>

            <div className="swiper-container pickslide-month">
              <div className="swiper-wrapper">
                <SettingMonth month={month} />
              </div>
            </div>

            <div className="swiper-container pickslide-day">
              <div className="swiper-wrapper">
                <SettingDate date={date} toYear={toYear} toMonth={toMonth} />
              </div>
            </div>
          </div>

          <div className="tbns-area">
            <a className="btn-round gray">취소</a>
            <a className="btn-round wht" onClick={() => setDateLayer()}>
              확인
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export const DateLayerPopup = (props) => {
  // const [ isDisplay, setIsDisplay ] = useState(false);
  const { startDate } = props;

  let toDay = new Date();
  let toMonthData = toDay.getMonth() + 1;
  if (toMonthData < 10) {
    toMonthData = "0" + toMonthData.toString();
  }

  // .map을 위한 배열 State
  const [year, setYear] = useState([]);
  const [month, setMonth] = useState([]);
  const [date, setDate] = useState([]);

  const [toYear, setToYear] = useState(
    startDate ? startDate.substring(0, 4) : toDay.getFullYear().toString()
  );
  const [toMonth, setToMonth] = useState(startDate ? startDate.substring(4, 6) : toMonthData);
  // const [toDate, setToDate] = useState(toDay.getDate());
  const [toDate, setToDate] = useState(startDate ? startDate.substring(6, 8) : toDay.getDate());

  const [oriYear, setOriYear] = useState(
    startDate ? startDate.substring(0, 4) : toDay.getFullYear().toString()
  );
  const [oriMonth, setOriMonth] = useState(startDate ? startDate.substring(4, 6) : toMonthData);
  const [oriDate, setOriDate] = useState(startDate ? startDate.substring(6, 8) : toDay.getDate());

  // setState를 위한 배열
  let yearArr = [];
  let monthArr = [];
  let dateArr = [];

  const closePopup = () => {
    props.setIsDisplay(false);
    $(".two-btns-area").show();
  };

  const settingYear = () => {
    // 오늘 년도-2 ~ 오늘 년도
    // 태어난 년도
    let birthYear = getCookie("birth") ? parseInt(getCookie("birth").substring(0, 4)) : toYear - 2;

    for (let i = toYear; i >= birthYear; i--) {
      yearArr.push(i);
    }
    setYear(yearArr);
  };

  const settingMonth = () => {
    // 1월~12월
    for (let i = 1; i <= 12; i++) {
      if (i < 10) {
        monthArr.push("0" + i);
      } else {
        monthArr.push(i);
      }
    }
    setMonth(monthArr);
  };

  const settingDate = () => {
    // 1일~최대일
    for (let i = 1; i <= lastDate; i++) {
      if (i < 10) {
        dateArr.push("0" + i);
      } else {
        dateArr.push(i);
      }
    }
    setDate(dateArr);
  };

  const settingLastDate = (toYear, toMonth) => {
    lastDate = new Date(toYear, toMonth, 0).getDate();
    settingDate();
  };

  const pickerStart = (setToYear, setToMonth, toYearIdx, toMonth, toDate) => {
    //일시 설정 레이어 스크롤링 스크립트
    //년
    pickslideYear = new Swiper(".pickslide-year", {
      // Optional parameters
      direction: "vertical",
      loop: true,
      slidesPerView: 5,
      centeredSlides: true,
      longSwipesMs: 100,
      on: {
        slideChangeTransitionEnd: function () {
          yearInvalue = $(".pickslide-year .swiper-slide-active span").html();
          setToYear(yearInvalue.substring(0, 4));
        },
      },

      observer: true,
      observeParents: true,
      observeSlideChildren: true,
    });

    //월
    pickslideMonth = new Swiper(".pickslide-month", {
      // Optional parameters
      direction: "vertical",
      loop: true,
      initialSlide: parseInt(toMonth - 1),
      slidesPerView: 5,
      centeredSlides: true,
      longSwipesMs: 100,

      on: {
        slideChangeTransitionEnd: function () {
          if ($(".pickslide-month .swiper-slide-active span").html()) {
            monthInvalue = $(".pickslide-month .swiper-slide-active span").html();
          } else {
            monthInvalue = toMonth + "월";
          }
          setToMonth(monthInvalue.substring(0, 2));
        },
      },

      // 스타일을 변경하거나 하위 요소를 수정할 떄마다 swiper 초기화
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
    });

    //일
    pickslideDay = new Swiper(".pickslide-day", {
      // Optional parameters
      direction: "vertical",
      // loop: true,
      initialSlide: parseInt(toDate) - 1,
      slidesPerView: 5,
      centeredSlides: true,
      longSwipesMs: 100,

      on: {
        slideChangeTransitionEnd: function () {
          // dayInvalue = $(".pickslide-day .swiper-slide-active span").html();
          if ($(".pickslide-month .swiper-slide-active span").html()) {
            dayInvalue = $(".pickslide-day .swiper-slide-active span").html();
          } else {
            dayInvalue = toDate + "일";
          }

          setToDate(dayInvalue.substring(0, 2));
        },
      },
      // 스타일을 변경하거나 하위 요소를 수정할 떄마다 swiper 초기화
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
    });
  };

  useEffect(() => {
    settingYear();
    settingMonth();
  }, []);

  useEffect(() => {
    // test
    settingLastDate(toYear, toMonth);
  }, [toYear, toMonth]);

  useEffect(() => {
    if (props.isDisplay) {
      pickerEndFn();
      pickerStart(setToYear, setToMonth, oriYear, oriMonth, oriDate);
    } else {
      pickerEndFn();
    }
  }, [props.isDisplay]);

  return (
    <Fragment>
      {props.isDisplay && (
        <div
          className="blacklayer-container date-input-layer"
          id={"dateLayer"}
          style={{ display: "block" }}
        >
          <div className="bl-blind"></div>
          <div className="in-layerarea nobtn">
            <div
              className={props.color === "green" ? "blgrn-box vertical" : "blgrn-box vertical priv"}
            >
              <div className="blgr-title">일시 설정</div>

              <div className="picker-container w3">
                <div className="swiper-container pickslide-year">
                  <div className="swiper-wrapper">
                    {year != [] && year.length > 0 && <SettingYear year={year} />}
                  </div>
                </div>

                <div className="swiper-container pickslide-month">
                  <div className="swiper-wrapper">
                    <SettingMonth month={month} />
                  </div>
                </div>

                <div className="swiper-container pickslide-day">
                  <div className="swiper-wrapper">
                    <SettingDate date={date} toYear={toYear} toMonth={toMonth} />
                  </div>
                </div>
              </div>

              <div className="tbns-area">
                <a className="btn-round gray" onClick={() => closePopup()}>
                  취소
                </a>
                <a
                  className="btn-round wht"
                  onClick={() => {
                    props.settingSearchFromDate(
                      toYear.toString() + toMonth.toString() + toDate.toString()
                    );
                    $(".two-btns-area").show();
                  }}
                >
                  확인
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export const DateLayerHist = (props) => {
  const { handleDate, color, id, setCalendar, setLoading } = props;

  let toDay = new Date();

  let toMonthData = toDay.getMonth() + 1;

  if (toMonthData < 10) {
    toMonthData = "0" + toMonthData.toString();
  }

  const [toYear, setToYear] = useState(toDay.getFullYear().toString());
  const [toMonth, setToMonth] = useState(toMonthData);
  const [toDate, setToDate] = useState(toDay.getDate());

  const [oriYear, setOriYear] = useState(toDay.getFullYear().toString());
  const [oriMonth, setOriMonth] = useState(toMonthData);
  const [oriDate, setOriDate] = useState(toDay.getDate());

  // setState를 위한 배열
  let yearArr = [];
  let monthArr = [];
  let dateArr = [];

  // .map을 위한 배열 State
  const [year, setYear] = useState([]);
  const [month, setMonth] = useState([]);
  const [date, setDate] = useState([]);

  const settingYear = () => {
    // 오늘 년도-2 ~ 오늘 년도
    // for(let i=(toYear-2); i<=toYear; i++) {
    for (let i = parseInt(toYear) - 5; i <= parseInt(toYear) + 5; i++) {
      yearArr.push(i);
    }
    setYear(yearArr);
  };

  const settingMonth = () => {
    // 1월~12월
    for (let i = 1; i <= 12; i++) {
      if (i < 10) {
        monthArr.push("0" + i);
      } else {
        monthArr.push(i);
      }
    }
    setMonth(monthArr);
  };

  const settingDate = () => {
    // 1일~최대일
    for (let i = 1; i <= lastDate; i++) {
      if (i < 10) {
        dateArr.push("0" + i);
      } else {
        dateArr.push(i);
      }
    }
    setDate(dateArr);
  };

  const settingLastDate = (toYear, toMonth) => {
    lastDate = new Date(toYear, toMonth, 0).getDate();
    settingDate();
  };

  useEffect(() => {
    //열기
    $(".date-picker-input").off("click");
    $(".date-input-layer .tbns-area a").off("click");

    $(".date-picker-input").click(function () {
      // inputBox가 값이 있으면 해당 값 기본값으로 open
      // inputBox에 값이 없으면 오늘 날짜 기본값으로
      checkCrInNum = $(this).data("num");
      openLayerFn($(".date-input-layer"));
      // openLayerFn($("#dateLayer"+id));

      // from, to 구분부터 checkCrInNum (1:from 2:to)
      if (checkCrInNum == "1") {
        if ($(".pick-num1").val() != "") {
          pickerStartHist(
            setToYear,
            setToMonth,
            toYear - $(".pick-num1").val().split(".")[0],
            $(".pick-num1").val().split(".")[1],
            $(".pick-num1").val().split(".")[2]
          );
        } else {
          pickerStartHist(setToYear, setToMonth, 0, oriMonth, oriDate);
        }
      } else {
        if ($(".pick-num2").val() != "") {
          pickerStartHist(
            setToYear,
            setToMonth,
            toYear - $(".pick-num2").val().split(".")[0],
            $(".pick-num2").val().split(".")[1],
            $(".pick-num2").val().split(".")[2]
          );
        } else {
          pickerStartHist(setToYear, setToMonth, 0, oriMonth, oriDate);
        }
      }
    });

    //닫기
    $(".date-input-layer .tbns-area a").click(function () {
      //확인버튼일 경우 선택값 적용
      if ($(this).hasClass("wht")) {
        dayInvalue = $(".pickslide-day .swiper-slide-active span").html();
        var totalValue =
          yearInvalue.slice(0, -1) +
          "." +
          monthInvalue.slice(0, -1) +
          "." +
          dayInvalue.slice(0, -1);
        const dateValue =
          yearInvalue.slice(0, -1) + monthInvalue.slice(0, -1) + dayInvalue.slice(0, -1);

        if (checkCrInNum == "1") {
          $(".pick-num1").val(totalValue);
          if (handleDate != null) handleDate("1", dateValue);
        } else if (checkCrInNum == "2") {
          $(".pick-num2").val(totalValue);
          if (handleDate != null) handleDate("2", dateValue);
        }

        if (setCalendar) {
          setCalendar(false);
        }

        setLoading(true);
      }
      pickerEndFn();
      closeLayerFn($(".date-input-layer"));
    });
    // },[]);
  }, [toYear, toMonth, toDate]);
  //);

  useEffect(() => {
    settingYear();
    settingMonth();
  }, []);

  useEffect(() => {
    // test
    settingLastDate(toYear, toMonth);
  }, [toYear, toMonth]);

  return (
    <div className="blacklayer-container date-input-layer" id={"dateLayer" + id}>
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div className={color === "green" ? "blgrn-box vertical" : "blgrn-box vertical priv"}>
          <div className="blgr-title">일시 설정</div>

          <div className="picker-container w3">
            <div className="swiper-container pickslide-year">
              <div className="swiper-wrapper">
                {year != [] && year.length > 0 && <SettingYear year={year} />}
              </div>
            </div>

            <div className="swiper-container pickslide-month">
              <div className="swiper-wrapper">
                <SettingMonth month={month} />
              </div>
            </div>

            <div className="swiper-container pickslide-day">
              <div className="swiper-wrapper">
                <SettingDate date={date} toYear={toYear} toMonth={toMonth} />
              </div>
            </div>
          </div>

          <div className="tbns-area">
            <a className="btn-round gray">취소</a>
            <a className="btn-round wht">확인</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export const DeviceBpBuyLayer = (props) => {
  const { phonecfg } = useContext(AppContext);
  const { setIsBuyBpDisplay } = props;

  const onClickBuyOmron = () => {
    NativeViewOpen(phonecfg.phoneOS, "https://smartstore.naver.com/mdpharmer/products/8012286653");
  };

  const onClickBuyInbody = () => {
    NativeViewOpen(phonecfg.phoneOS, "https://smartstore.naver.com/mdpharmer/products/5533533271");
  };

  const onClickClose = () => {
    document.getElementsByTagName("body")[0].classList.remove("scrollLock");
    setIsBuyBpDisplay(false);
  };

  useEffect(() => {
    document.getElementsByTagName("body")[0].classList.add("scrollLock");
  }, []);

  return (
    <>
      <div className="blacklayer-container" style={{ display: "block" }}>
        <div className="bl-blind"></div>
        <div
          className="in-layerarea nobtn"
          style={{
            display: "block",
            textAlign: "-webkit-center",
            paddingLeft: "2px",
            paddingRight: "2px",
          }}
        >
          <div
            style={{
              width: "360px",
              height: "480px",
              marginTop: "80px",
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "20px",
              backgroundColor: "#FFFFFF",
            }}
          >
            <div
              style={{
                height: "40px",
                textAlign: "center",
                font: "normal normal bold 16px/50px Pretendard",
                color: "#A0A0A0",
              }}
            >
              블루투스 혈압계
            </div>
            <div
              style={{
                height: "30px",
                textAlign: "center",
                font: "normal normal normal 12px/30px Pretendard",
                color: "#A0A0A0",
              }}
            >
              케어포미와 연동되는 블루투스 혈압계를 구매하실 수 있습니다.
            </div>
            <div style={{ marginLeft: "10px", marginRight: "10px", border: "1px solid #E3E2E2" }} />
            <div style={{ display: "flex", paddingTop: "10px" }}>
              <div style={{ width: "60%" }}>
                <div
                  onClick={() => {
                    onClickBuyOmron();
                  }}
                  style={{
                    height: "30px",
                    paddingLeft: "20px",
                    textAlign: "left",
                    font: "normal normal bold 16px/28px Pretendard",
                  }}
                >
                  오므론 혈압계
                </div>
                <div
                  onClick={() => {
                    onClickBuyOmron();
                  }}
                  style={{
                    height: "30px",
                    paddingLeft: "20px",
                    textAlign: "left",
                    font: "normal normal bold 22px/28px Pretendard",
                    color: "#0297EE",
                  }}
                >
                  HEM-7142T2
                </div>
                <div style={{ height: "44px" }} />
                <div style={{ display: "flex" }}>
                  <div
                    style={{
                      height: "20px",
                      paddingLeft: "20px",
                      textAlign: "left",
                      font: "normal normal bold 16px/20px Pretendard",
                    }}
                  >
                    69,000원
                  </div>
                  <div
                    style={{
                      width: "60px",
                      height: "20px",
                      borderRadius: "8px",
                      backgroundColor: "#FFF0E5",
                      color: "#D87D4B",
                      fontSize: "12px",
                      textAlign: "center",
                      marginLeft: "7px",
                      lineHeight: "20px",
                    }}
                  >
                    무료배송
                  </div>
                </div>
                <div
                  style={{
                    height: "30px",
                    paddingLeft: "20px",
                    textAlign: "left",
                    font: "normal normal normal 12px/23px Pretendard",
                    color: "#A0A0A0",
                  }}
                >
                  #작은 사이즈 #국제기준 검증제품
                </div>
              </div>
              <div style={{ marginLeft: "auto" }}>
                <div
                  onClick={() => {
                    onClickBuyOmron();
                  }}
                  style={{ height: "113px", paddingRight: "10px" }}
                >
                  <img src={_T_DEVICE_OMRON_IMAGE} style={{ width: "127px" }} />
                </div>
                <div style={{ height: "28px", paddingRight: "10px", textAlign: "right" }}>
                  <div
                    onClick={() => {
                      onClickBuyOmron();
                    }}
                    style={{
                      width: "100px",
                      height: "28px",
                      borderRadius: "10px",
                      backgroundColor: "#0297EE",
                      color: "#FFFFFF",
                      fontSize: "14px",
                      textAlign: "center",
                      lineHeight: "28px",
                      display: "inline-block",
                    }}
                  >
                    구매하기
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{ marginLeft: "10px", marginRight: "10px", border: "1px dashed #E3E2E2" }}
            />
            <div style={{ display: "flex", paddingTop: "5px" }}>
              <div style={{ width: "70%" }}>
                <div
                  onClick={() => {
                    onClickBuyInbody();
                  }}
                  style={{
                    height: "30px",
                    paddingLeft: "20px",
                    textAlign: "left",
                    font: "normal normal bold 16px/28px Pretendard",
                  }}
                >
                  인바디 혈압계
                </div>
                <div
                  onClick={() => {
                    onClickBuyInbody();
                  }}
                  style={{
                    height: "30px",
                    paddingLeft: "20px",
                    textAlign: "left",
                    font: "normal normal bold 22px/28px Pretendard",
                    color: "#0297EE",
                  }}
                >
                  BP-170B
                </div>
                <div style={{ height: "44px" }} />
                <div style={{ display: "flex" }}>
                  <div
                    style={{
                      height: "20px",
                      paddingLeft: "20px",
                      textAlign: "left",
                      font: "normal normal bold 16px/20px Pretendard",
                    }}
                  >
                    90,000원
                  </div>
                  <div
                    style={{
                      width: "60px",
                      height: "20px",
                      borderRadius: "8px",
                      backgroundColor: "#FFF0E5",
                      color: "#D87D4B",
                      fontSize: "12px",
                      textAlign: "center",
                      marginLeft: "7px",
                      lineHeight: "20px",
                    }}
                  >
                    무료배송
                  </div>
                </div>
                <div
                  style={{
                    height: "30px",
                    paddingLeft: "20px",
                    textAlign: "left",
                    font: "normal normal normal 12px/23px Pretendard",
                    color: "#A0A0A0",
                  }}
                >
                  #큰화면 #국내생산 및 AS #국제기준 검증제품
                </div>
              </div>
              <div style={{ marginLeft: "auto" }}>
                <div
                  onClick={() => {
                    onClickBuyInbody();
                  }}
                  style={{ height: "113px", paddingRight: "10px" }}
                >
                  <img src={_T_DEVICE_INBODY_IMAGE} style={{ width: "100px" }} />
                </div>
                <div style={{ height: "28px", paddingRight: "10px", textAlign: "right" }}>
                  <div
                    onClick={() => {
                      onClickBuyInbody();
                    }}
                    style={{
                      width: "100px",
                      height: "28px",
                      borderRadius: "10px",
                      backgroundColor: "#0297EE",
                      color: "#FFFFFF",
                      fontSize: "14px",
                      textAlign: "center",
                      lineHeight: "28px",
                      display: "inline-block",
                    }}
                  >
                    구매하기
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{ marginLeft: "10px", marginRight: "10px", border: "1px dashed #E3E2E2" }}
            />
            <div
              style={{
                height: "40px",
                paddingTop: "5px",
                textAlign: "center",
                font: "normal normal normal 14px/30px Pretendard",
                color: "#0297EE",
              }}
            >
              <img
                src={_T_DEVICE_ICON_TALK}
                style={{
                  width: "16px",
                  display: "inline-block",
                  marginRight: "5px",
                  verticalAlign: "middle",
                }}
              />
              <a
                href="tel:0314344846"
                style={{ font: "normal normal normal 14px/30px Pretendard", color: "#0297EE" }}
              >
                전화구매 및 문의 031-434-4846
              </a>
            </div>
            <div
              onClick={() => {
                onClickClose();
              }}
              style={{
                height: "40px",
                backgroundColor: "#0297EE",
                color: "#FFFFFF",
                font: "normal normal normal 14px/40px Pretendard",
                textAlign: "center",
              }}
            >
              닫기
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const DeviceBsBuyLayer = (props) => {
  const { phonecfg } = useContext(AppContext);
  const { setIsBuyBsDisplay } = props;

  const onClickBuyGlueNeo = () => {
    NativeViewOpen(phonecfg.phoneOS, "https://smartstore.naver.com/mdpharmer/products/7721990241");
  };

  const onClickClose = () => {
    document.getElementsByTagName("body")[0].classList.remove("scrollLock");
    setIsBuyBsDisplay(false);
  };

  useEffect(() => {
    document.getElementsByTagName("body")[0].classList.add("scrollLock");
  }, []);

  return (
    <>
      <div className="blacklayer-container" style={{ display: "block" }}>
        <div className="bl-blind"></div>
        <div
          className="in-layerarea nobtn"
          style={{
            display: "block",
            textAlign: "-webkit-center",
            paddingLeft: "2px",
            paddingRight: "2px",
          }}
        >
          <div
            style={{
              width: "360px",
              height: "311px",
              marginTop: "50%",
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "20px",
              backgroundColor: "#FFFFFF",
            }}
          >
            <div
              style={{
                height: "40px",
                textAlign: "center",
                font: "normal normal bold 16px/50px Pretendard",
                color: "#A0A0A0",
              }}
            >
              블루투스 혈당계
            </div>
            <div
              style={{
                height: "30px",
                textAlign: "center",
                font: "normal normal normal 12px/30px Pretendard",
                color: "#A0A0A0",
              }}
            >
              케어포미와 연동되는 블루투스 혈당계를 구매하실 수 있습니다.
            </div>
            <div style={{ marginLeft: "10px", marginRight: "10px", border: "1px solid #E3E2E2" }} />
            <div style={{ display: "flex", paddingTop: "5px" }}>
              <div style={{ width: "70%" }}>
                <div
                  onClick={() => {
                    onClickBuyGlueNeo();
                  }}
                  style={{
                    height: "30px",
                    paddingLeft: "20px",
                    textAlign: "left",
                    font: "normal normal bold 16px/40px Pretendard",
                  }}
                >
                  오상헬스케어 혈당계
                </div>
                <div
                  onClick={() => {
                    onClickBuyGlueNeo();
                  }}
                  style={{
                    height: "30px",
                    paddingLeft: "20px",
                    textAlign: "left",
                    font: "normal normal bold 22px/28px Pretendard",
                    color: "#0297EE",
                  }}
                >
                  글루네오스마트
                </div>
                <div style={{ height: "28px", paddingLeft: "20px", textAlign: "left" }}>
                  <div
                    onClick={() => {
                      onClickBuyGlueNeo();
                    }}
                    style={{
                      width: "100px",
                      height: "28px",
                      borderRadius: "10px",
                      backgroundColor: "#0297EE",
                      color: "#FFFFFF",
                      fontSize: "14px",
                      textAlign: "center",
                      lineHeight: "28px",
                      display: "inline-block",
                    }}
                  >
                    구매하기
                  </div>
                </div>
                <div style={{ height: "14px" }} />
                <div style={{ display: "flex" }}>
                  <div
                    style={{
                      height: "20px",
                      paddingLeft: "20px",
                      textAlign: "left",
                      font: "normal normal bold 16px/20px Pretendard",
                    }}
                  >
                    36,000원
                  </div>
                  <div
                    style={{
                      width: "70px",
                      height: "20px",
                      borderRadius: "8px",
                      backgroundColor: "#FFFFFF",
                      color: "#D87D4B",
                      fontSize: "12px",
                      textAlign: "center",
                      marginLeft: "7px",
                      lineHeight: "20px",
                    }}
                  >
                    시험지 미포함
                  </div>
                </div>
              </div>
              <div style={{ marginLeft: "auto" }}>
                <div
                  onClick={() => {
                    onClickBuyGlueNeo();
                  }}
                  style={{ height: "113px", paddingRight: "40px", paddingTop: "10px" }}
                >
                  <img src={_T_DEVICE_GLUENEO_IMAGE} style={{ width: "60px" }} />
                </div>
              </div>
            </div>
            <div
              style={{
                height: "17px",
                paddingLeft: "20px",
                textAlign: "left",
                font: "normal normal normal 12px/30px Pretendard",
                color: "#000000",
              }}
            >
              시험지(100개입) : 18,300원
            </div>
            <div
              style={{
                height: "17px",
                paddingLeft: "20px",
                textAlign: "left",
                font: "normal normal normal 12px/30px Pretendard",
                color: "#000000",
              }}
            >
              시험지+일회용 알콜솜+채혈침 세트(각 100개입) : 22,000원
            </div>
            <div
              style={{
                height: "17px",
                paddingLeft: "20px",
                paddingBottom: "17px",
                textAlign: "left",
                font: "normal normal normal 12px/30px Pretendard",
                color: "#000000",
              }}
            >
              (배송비가 3,500원 부과됩니다.)
            </div>
            <div
              style={{ marginLeft: "10px", marginRight: "10px", border: "1px dashed #E3E2E2" }}
            />
            <div
              style={{
                height: "40px",
                paddingTop: "5px",
                textAlign: "center",
                font: "normal normal normal 14px/30px Pretendard",
                color: "#0297EE",
                backgroundColor: "#FFF",
              }}
            >
              <img
                src={_T_DEVICE_ICON_TALK}
                style={{
                  width: "16px",
                  display: "inline-block",
                  marginRight: "5px",
                  verticalAlign: "middle",
                }}
              />
              <a
                href="tel:0314344846"
                style={{ font: "normal normal normal 14px/30px Pretendard", color: "#0297EE" }}
              >
                전화구매 및 문의 031-434-4846
              </a>
            </div>
            <div
              onClick={() => {
                onClickClose();
              }}
              style={{
                height: "40px",
                backgroundColor: "#0297EE",
                color: "#FFFFFF",
                font: "normal normal normal 14px/40px Pretendard",
                textAlign: "center",
              }}
            >
              닫기
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const DeviceInputLayer = (props) => {
  const { userinfo, phonecfg, cfg, dispatch, dvcBpInfo, dvcBsInfo } = useContext(AppContext);
  // 입력팝업.기기입력
  const [isDisplay, setIsDisplay] = useState(false);
  const [isManualDisplay, setIsManualDisplay] = useState(false);
  const [userDvcInfo, setUserDvcInfo] = useState({});
  const [selectFactory, setSelectFactory] = useState({});
  const [selectModel, setSelectModel] = useState({});
  const [drawFactorys, setDrawFactorys] = useState([]);
  const [drawModels, setDrawModels] = useState([]);

  const [dvcTitle, setDvcTitle] = useState("");
  const [inputType, setInputType] = useState("");

  const [errorMsg, setErrorMsg] = useState("");

  // 장비 목록 조회 (혈압,혈당장비)
  const requestDvcList = (dvcType) => {
    PostApiDvcList(phonecfg, cfg, dvcType)
      .then((res) => {
        if (res.resultMsg === "SUCC") {
          {
            if (dvcType == "BP") {
              dispatch({ type: SET_DEVICE_BP_LIST, data: res.result });
            } else {
              dispatch({ type: SET_DEVICE_BS_LIST, data: res.result });
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // 기기 등록 조회 (혈압,혈당장비) - 사용자 등록
  const requestDvcRegist = (dvcType) => {
    PostApi1960(userinfo, phonecfg, cfg, dvcType)
      .then((res) => {
        if (res.resultMsg === "SUCC") {
          setUserDvcInfo({
            typy: res.result.mnType,
            addType: res.result.dvcAddType,
            ftrCode: res.result.mnftrCd,
            ftrNm: res.result.mnftrNm,
            modelCode: res.result.modelCd,
            modelNm: res.result.modelNm,
            cDate: res.result.cDate,
          });

          setSelectFactory({
            code: res.result.mnftrCd,
            name: res.result.mnftrNm,
          });
          setSelectModel({
            code: res.result.modelCd,
            name: res.result.modelNm,
          });

          setDvcTitle(res.result.mnftrNm ? res.result.mnftrNm + " / " + res.result.modelNm : "");
          setInputType(res.result.dvcAddType);

          let toDay = new Date();

          if (res.result.mnftrCd == "") {
            if (dvcType == "BP") {
              if (!getCookie("dvcBpInputDate")) {
                setIsDisplay(true);
              } else {
                let pastDay = new Date(getCookie("dvcBpInputDate"));
                let remainingTime = Math.ceil((toDay - pastDay) / (24 * 60 * 60 * 1000));
                if (remainingTime >= 7) {
                  setIsDisplay(true);
                }
              }
            } else {
              if (!getCookie("dvcBsInputDate")) {
                setIsDisplay(true);
              } else {
                let pastDay = new Date(getCookie("dvcBsInputDate"));
                let remainingTime = Math.ceil((toDay - pastDay) / (24 * 60 * 60 * 1000));
                if (remainingTime >= 7) {
                  setIsDisplay(true);
                }
              }
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onOpenHandler = async () => {
    await new Promise((resolve) => {
      document.getElementsByTagName("body")[0].classList.add("scrollLock");
      resolve(props.setIsDisplay(true));
    });
  };

  const onCloseHandler = () => {
    setSelectFactory({
      code: userDvcInfo.ftrCode,
      name: userDvcInfo.ftrNm,
    });
    setSelectModel({
      code: userDvcInfo.modelCode,
      name: userDvcInfo.modelNm,
    });
    setInputType(userDvcInfo.addType);
    setErrorMsg("");
    let toDay = new Date();
    if (userDvcInfo.ftrCode == "") {
      if (props.type == "BP") {
        // if(!getCookie("dvcBpInputDate")) {
        setCookie("dvcBpInputDate", toDay, 365);
        // }
      } else {
        // if(!getCookie("dvcBsInputDate")) {
        setCookie("dvcBsInputDate", toDay, 365);
        // }
      }
    }

    document.getElementsByTagName("body")[0].classList.remove("scrollLock");
    setIsDisplay(false);
  };

  const onSetHandler = () => {
    if (!selectFactory.code || !selectModel.code) {
      if (inputType == "C") {
        setErrorMsg("선택되지 않은 항목이 있습니다");
      } else {
        setErrorMsg("입력되지 않은 항목이 있습니다");
      }
    } else {
      PostApi1961(
        userinfo,
        cfg,
        phonecfg,
        userDvcInfo.ftrCode ? "U" : "I",
        props.type,
        inputType,
        selectFactory.code,
        selectModel.code
      )
        .then((res) => {
          if (res.resultMsg === "SUCC") {
            {
              inputType == "C"
                ? setDvcTitle(selectFactory.name + " / " + selectModel.name)
                : setDvcTitle(selectFactory.code + " / " + selectModel.code);
              setUserDvcInfo({
                typy: props.type,
                addType: inputType,
                ftrCode: selectFactory.code,
                ftrNm: selectFactory.name,
                modelCode: selectModel.code,
                modelNm: selectModel.name,
                cDate: "",
              });
              // $("#title").html(selectFactory + " / " +  selectModel);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
      setIsDisplay(false);
      setErrorMsg("");
    }
  };

  useEffect(() => {
    if (props.type == "BP") {
      if (dvcBpInfo) {
        setDrawFactorys(
          dvcBpInfo.filter(function (data, index) {
            if (data.dvcType == "BP") {
              return true;
            }
          })
        );
      }
    } else {
      if (dvcBsInfo) {
        setDrawFactorys(
          dvcBsInfo.filter(function (data, index) {
            if (data.dvcType == "BS") {
              return true;
            }
          })
        );
      }
    }

    setDrawModels(
      drawFactorys.filter(function (data, index) {
        if (data.modelCd == selectFactory.code) {
          return true;
        }
      })
    );

    setSelectFactory({
      code: userDvcInfo.ftrCode,
      name: userDvcInfo.ftrNm,
    });

    setSelectModel({
      code: userDvcInfo.modelCode,
      name: userDvcInfo.modelNm,
    });
  }, [dvcBpInfo, dvcBsInfo]);

  useEffect(() => {
    setDrawModels(
      drawFactorys.filter(function (data, index) {
        if (data.modelCd == selectFactory.code) {
          return true;
        }
      })
    );
  }, [selectFactory]);

  // 화면 그리기 전 호출
  useEffect(() => {
    requestDvcRegist(props.type);
    if (dvcBpInfo.length < 1) {
      // 혈압 기기 목록이 없을 경우
      requestDvcList(props.type);
    }

    if (dvcBsInfo.length < 1) {
      // 혈당 기기 목록이 없을 경우
      requestDvcList(props.type);
    }
  }, []);

  return (
    <>
      <input
        onClick={onOpenHandler}
        type="text"
        className="textbox datetime-picker-input"
        id="title"
        style={{ height: "46px", lineHeight: "54px", fontSize: "0.9rem" }}
        placeholder={props.typeNm + " 측정기 등록"}
        value={props.dvcTitle ? props.dvcTitle : dvcTitle}
        readOnly
      />
    </>
  );
};

// 중복 체크
export const DateTimeLayer = (props) => {
  const { setBpcDate, setBpcTime, type, bpcTime, bpcDate } = props;

  let dateArr = [];
  const [date, setDate] = useState([]);
  const [isDisplay, setIsDisplay] = useState(false);

  const [selectedDate, setSelectedDate] = useState(bpcDate);
  const [selectedTime, setSelectedTime] = useState(bpcTime);
  const [selectedMin, setSelectedMin] = useState(bpcTime.substring(2, 4));
  const [selectedAmPm, setSelectedAmPm] = useState(
    // $(".pickslide-ampm .swiper-slide-active span").html()
    parseInt(bpcTime.substring(0, 2)) >= 12 ? "오후" : "오전"
  );
  const [realIdx, setRealIdx] = useState(date.length);

  // 출력할 날짜 (이번달, 저번달)
  const toDay = new Date();
  // 이번달
  const toYear = toDay.getFullYear();
  const toMonth = toDay.getMonth() + 1;
  const toDate = toDay.getDate();
  const fullDate =
    toDay.getFullYear() + "" + checkNum10(toDay.getMonth() + 1) + "" + checkNum10(toDay.getDate());

  // 현재시간
  const timeNow = toDay.getHours();
  const minNow = toDay.getMinutes();
  const amPmNow = toDay.getHours() >= 12 ? "오후" : "오전";

  let lastYear;
  let lastMonth;

  if (toMonth == 1) {
    lastYear = toYear - 1;
    lastMonth = 12;
  } else {
    lastYear = toYear;
    lastMonth = toMonth - 1;

    if (lastMonth == 0) {
      lastMonth = 12;
    }
  }

  //요일 설정
  const week = new Array("일", "월", "화", "수", "목", "금", "토");

  // 날짜 배열 생성 (월 일 요일)
  const setRow = (toMonth, toYear, toDate, lastMonth, lastYear, week) => {
    let getDate;
    let day;
    let month;

    // let totalDate = new Date(toYear, toMonth, 0).getDate();
    let totalLastDate = new Date(lastYear, lastMonth, 0).getDate();

    // 과거 날짜 리스트 생성
    for (let i = 1; i <= totalLastDate; i++) {
      getDate = new Date(lastYear + "/" + lastMonth + "/" + i).getDay();
      day = week[getDate];

      if (lastMonth < 10) {
        month = "0" + lastMonth;
      } else {
        month = lastMonth;
      }

      if (i < 10) {
        dateArr.push({
          key: lastYear + "" + month + "0" + i,
          year: lastYear,
          month: toMonth - 1 == 0 ? 12 : toMonth - 1,
          date: "0" + i,
          day: day,
        });
      } else {
        dateArr.push({
          key: lastYear + "" + month + i,
          year: lastYear,
          month: toMonth - 1 == 0 ? 12 : toMonth - 1,
          date: i,
          day: day,
        });
      }
    }

    // 이번달 날짜 리스트 생성
    for (let i = 1; i <= toDate; i++) {
      getDate = new Date(toYear + "/" + toMonth + "/" + i).getDay();
      day = week[getDate];

      if (toMonth < 10) {
        month = "0" + toMonth;
      } else {
        month = toMonth;
      }

      if (i < 10) {
        dateArr.push({
          key: toYear + "" + month + "0" + i,
          year: toYear,
          month: toMonth,
          date: "0" + i,
          day: day,
        });
      } else {
        dateArr.push({
          key: toYear + "" + month + i,
          year: toYear,
          month: toMonth,
          date: i,
          day: day,
        });
      }
    }
    // state에 dateArr Set
    setDate(dateArr);
    setRealIdx(dateArr.length - 1);
  };

  const onOpenHandler = async () => {
    await new Promise((resolve) => {
      resolve(setIsDisplay(true));
    });

    pickerStartFn(
      dateArr,
      selectedDate,
      setSelectedDate,
      selectedTime,
      setSelectedTime,
      selectedMin,
      setSelectedMin,
      selectedAmPm,
      setSelectedAmPm,
      realIdx,
      setRealIdx
    );
  };

  const onConfirmHandler = () => {
    ampmInvalue = $(".pickslide-ampm .swiper-slide-active span").html();

    var totalValue =
      keyInvalue.substring(0, 4) +
      "-" +
      keyInvalue.substring(4, 6) +
      "-" +
      keyInvalue.substring(6, 8) +
      " (" +
      dateInvalue.split(" ")[2] +
      ") " +
      (ampmInvalue === "오전" ? hourInvalue : (parseInt(hourInvalue) + 12).toString()) +
      ":" +
      minuteInvalue;

    $("#inputDateView").val(totalValue);

    // 여기서 날짜 변환이 필요함
    inptHourInvalue = parseInt(hourInvalue);
    if (ampmInvalue === "오전") {
      if (inptHourInvalue == 12) {
        inptHourInvalue = inptHourInvalue - 12;
      }
    }

    if (ampmInvalue === "오후") {
      if (inptHourInvalue < 12) {
        inptHourInvalue = inptHourInvalue + 12;
      }
    }

    if (inptHourInvalue < 10) {
      inptHourInvalue = "0" + inptHourInvalue;
    }
    inptTimeInvalue = inptHourInvalue + inptMinInvalue;

    setBpcDate(keyInvalue);
    setBpcTime(inptTimeInvalue);
    // 선택한 년도 유지
    setRealIdx(pickslideDate.realIndex);
    onCloseHandler();
  };

  const onCloseHandler = () => {
    pickerEndFn();
    // closeLayerFn($(".datetime-input-layer"));
    setIsDisplay(false);
  };

  useEffect(() => {
    setRow(toMonth, toYear, toDate, lastMonth, lastYear, week);
  }, []);

  let defaultYear = toDay.getFullYear();
  let defaultMonth = toDay.getMonth() + 1;
  let defaultDate = toDay.getDate();

  let defaultHours = toDay.getHours();
  let defaultMin = toDay.getMinutes();

  let defaultDay = week[toDay.getDay()];
  let defaultAmPm;

  if (defaultHours < 12) {
    defaultAmPm = "오전";
  } else {
    defaultAmPm = "오후";
  }

  if (defaultMonth < 10) {
    defaultMonth = "0" + defaultMonth;
  }

  if (defaultDate < 10) {
    defaultDate = "0" + defaultDate;
  }

  if (defaultHours < 10) {
    defaultHours = "0" + defaultHours;
  }

  if (defaultMin < 10) {
    defaultMin = "0" + defaultMin;
  }

  // 9월 28일 화 오전 08:50
  // 2022.09.28(화) 17:15
  const defaultValue =
    defaultYear +
    "-" +
    defaultMonth +
    "-" +
    defaultDate +
    " " +
    "(" +
    defaultDay +
    ")" +
    " " +
    defaultHours +
    ":" +
    defaultMin;

  useEffect(() => {
    $("#htmlBody").css("overflow", isDisplay ? "hidden" : "auto");
  }, [isDisplay]);
  return (
    <>
      <input
        onClick={onOpenHandler}
        type="text"
        className="textbox datetime-picker-input pick-result"
        id="inputDateView"
        style={{ height: "50px", lineHeight: "50px", fontSize: "0.9rem" }}
        placeholder="날짜/시간을 선택해 주세요."
        defaultValue={defaultValue}
        readOnly
      />
      {isDisplay && (
        <div className="blacklayer-container" style={{ display: "block" }}>
          <div className="bl-blind"></div>
          <div className="in-layerarea nobtn">
            <div className="blgrn-box vertical" style={{ position: "fixed" }}>
              <div className="blgr-title"></div>

              <div className="picker-container w4">
                <div className="swiper-container pickslide-date">
                  <div className="swiper-wrapper">
                    {date.map((m, i) => (
                      <div className="swiper-slide" key={i} id={m.key} name={i}>
                        <span>
                          {m.month}월 {m.date}일 {m.day}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="swiper-container pickslide-ampm">
                  <div className="swiper-wrapper">
                    <div className="swiper-slide">
                      <span>오전</span>
                    </div>

                    {(selectedDate != fullDate || parseInt(timeNow) >= 12) && (
                      <div className="swiper-slide">
                        <span>오후</span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="swiper-container pickslide-hour">
                  <div className="swiper-wrapper">
                    {
                      <TimeComponent
                        type={"hour"}
                        dateNow={selectedDate === fullDate ? true : false}
                        timeNow={
                          selectedTime.substring(0, 2) === checkNum10(timeNow).toString()
                            ? true
                            : false
                        }
                        amPmNow={amPmNow === selectedAmPm ? true : false}
                        fullDate={fullDate}
                        bpcTime={bpcTime}
                        bpcDate={bpcDate}
                      />
                    }
                  </div>
                </div>

                <div className="swiper-container pickslide-minute">
                  <div className="swiper-wrapper">
                    {
                      <TimeComponent
                        type={"min"}
                        dateNow={selectedDate === fullDate ? true : false}
                        timeNow={
                          selectedTime.substring(0, 2).toString() === checkNum10(timeNow).toString()
                            ? true
                            : selectedAmPm === "오후"
                            ? (parseInt(selectedTime.substring(0, 2)) + 12).toString() ===
                                checkNum10(timeNow).toString() && true
                            : false
                        }
                        amPmNow={amPmNow === selectedAmPm ? true : false}
                        fullDate={fullDate}
                        bpcTime={bpcTime}
                        bpcDate={bpcDate}
                      />
                    }
                  </div>
                </div>
                <i className="dots"></i>
              </div>

              <div className="tbns-area">
                <a href={void 0} className="btn-round gray" onClick={onCloseHandler}>
                  취소
                </a>
                <a className="btn-round wht" onClick={onConfirmHandler}>
                  확인
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const TimeComponent = (props) => {
  const { type, dateNow, timeNow, amPmNow, bpcTime, bpcDate } = props;
  let maxIndex = 0;
  let startIndex = 0;

  let date = new Date();
  let nowHour = date.getHours();
  // let nowHour = 12;
  let nowMin = date.getMinutes();

  // hour, min
  // 미래시점 입력 불가
  if (type == "hour") {
    if (dateNow == true) {
      startIndex = 0;
      if (nowHour >= 12) {
        if (amPmNow) {
          maxIndex = nowHour - 12;
        } else {
          maxIndex = 11;
        }
      } else {
        maxIndex = nowHour;
      }
    } else {
      startIndex = 0;
      maxIndex = 11;
    }
  } else {
    if (dateNow == true && timeNow == true) {
      startIndex = 0;
      maxIndex = nowMin;
    } else {
      startIndex = 0;
      maxIndex = 59;
    }
  }

  const componentDrawLoop = (maxIndex) => {
    let arr = [];

    for (let index = startIndex; index <= maxIndex; index++) {
      arr.push(
        <div className="swiper-slide" key={type + index}>
          <span>{checkNum10(index)}</span>
        </div>
      );
    }

    return arr;
  };

  return <Fragment>{componentDrawLoop(maxIndex)}</Fragment>;
};

// 중복 체크
export const DateTimeLayerMod = (props) => {
  const { setBpcDate, setBpcTime, type, setBpcTimeCd, viewDate, viewTime, viewDay } = props;

  let dateArr = [];
  const [date, setDate] = useState([]);
  const [isDisplay, setIsDisplay] = useState(false);

  const [selectedDate, setSelectedDate] = useState(viewDate);
  const [selectedTime, setSelectedTime] = useState(viewTime);
  const [selectedMin, setSelectedMin] = useState(viewTime.substring(2, 4));
  const [selectedAmPm, setSelectedAmPm] = useState(
    // $(".pickslide-ampm .swiper-slide-active span").html()
    parseInt(viewTime.substring(0, 2)) >= 12 ? "오후" : "오전"
  );

  // const [realIdx, setRealIdx] = useState(getRealIdx);

  // 출력할 날짜 (이번달, 저번달)
  const toDay = new Date();
  // 이번달
  const toYear = toDay.getFullYear();
  const toMonth = toDay.getMonth() + 1;
  const toDate = toDay.getDate();
  const fullDate =
    toDay.getFullYear() + "" + checkNum10(toDay.getMonth() + 1) + "" + checkNum10(toDay.getDate());

  // 현재시간
  const timeNow = toDay.getHours();
  const minNow = toDay.getMinutes();
  const amPmNow = toDay.getHours() >= 12 ? "오후" : "오전";

  let lastYear;
  let lastMonth;

  if (toMonth == 1) {
    lastYear = toYear - 1;
    lastMonth = 12;
  } else {
    lastYear = toYear;
    lastMonth = toMonth - 1;
  }

  //요일 설정
  const week = new Array("일", "월", "화", "수", "목", "금", "토");

  const getRealIdx = () => {
    let returnData = 0;

    if (new Date().getMonth() + 1 === parseInt(viewDate.substring(4, 6))) {
      returnData =
        parseInt(new Date(lastYear, lastMonth, 0).getDate()) +
        parseInt(viewDate.substring(6, 8)) -
        1;
    } else {
      returnData = parseInt(viewDate.substring(6, 8)) - 1;
    }

    return returnData;
  };

  const [realIdx, setRealIdx] = useState(getRealIdx());

  // 날짜 배열 생성 (월 일 요일)
  const setRow = (toMonth, toYear, toDate, lastMonth, lastYear, week) => {
    let getDate;
    let day;
    let month;

    // let totalDate = new Date(toYear, toMonth, 0).getDate();
    let totalLastDate = new Date(lastYear, lastMonth, 0).getDate();

    // 과거 날짜 리스트 생성
    for (let i = 1; i <= totalLastDate; i++) {
      let lastMonthData = lastMonth;
      getDate = new Date(lastYear + "/" + lastMonth + "/" + i).getDay();
      day = week[getDate];

      if (lastMonth < 10) {
        lastMonthData = "0" + lastMonth;
      }

      if (i < 10) {
        dateArr.push({
          key: lastYear + "" + lastMonthData + "0" + i,
          year: lastYear,
          month: lastMonthData,
          date: "0" + i,
          day: day,
        });
      } else {
        dateArr.push({
          key: lastYear + "" + lastMonthData + i,
          year: lastYear,
          month: lastMonthData,
          date: i,
          day: day,
        });
      }
    }

    // 이번달 날짜 리스트 생성
    for (let i = 1; i <= toDate; i++) {
      // getDate = new Date(toYear + "-" + toMonth + "-" + i).getDay();
      getDate = new Date(toYear + "/" + toMonth + "/" + i).getDay();
      day = week[getDate];

      if (toMonth < 10) {
        month = "0" + toMonth;
      } else {
        month = toMonth;
      }

      if (i < 10) {
        dateArr.push({
          key: toYear + "" + month + "0" + i,
          year: toYear,
          month: toMonth,
          date: "0" + i,
          day: day,
        });
      } else {
        dateArr.push({
          key: toYear + "" + month + i,
          year: toYear,
          month: toMonth,
          date: i,
          day: day,
        });
      }
    }
    // state에 dateArr Set
    setDate(dateArr);
  };

  const onOpenHandler = async () => {
    await new Promise((resolve) => {
      resolve(setIsDisplay(true));
    });

    pickerStartFn(
      date,
      selectedDate,
      setSelectedDate,
      selectedTime,
      setSelectedTime,
      selectedMin,
      setSelectedMin,
      selectedAmPm,
      setSelectedAmPm,
      realIdx,
      setRealIdx
    );
  };

  const onConfirmHandler = () => {
    ampmInvalue = $(".pickslide-ampm .swiper-slide-active span").html();
    // var totalValue = dateInvalue + " " + ampmInvalue + " " + hourInvalue + ":" + minuteInvalue;
    var totalValue =
      keyInvalue.substring(0, 4) +
      "-" +
      keyInvalue.substring(4, 6) +
      "-" +
      keyInvalue.substring(6, 8) +
      " (" +
      dateInvalue.split(" ")[2] +
      ") " +
      (ampmInvalue === "오전" ? hourInvalue : (parseInt(hourInvalue) + 12).toString()) +
      ":" +
      minuteInvalue;

    $("#mealTimeInput").val(totalValue);

    // 여기서 날짜 변환이 필요함
    inptHourInvalue = parseInt(hourInvalue);
    if (ampmInvalue === "오전") {
      if (inptHourInvalue == 12) {
        inptHourInvalue = inptHourInvalue - 12;
      }
    }

    if (ampmInvalue === "오후") {
      if (inptHourInvalue < 12) {
        inptHourInvalue = inptHourInvalue + 12;
      }
    }

    if (inptHourInvalue < 10) {
      inptHourInvalue = "0" + inptHourInvalue;
    }
    inptTimeInvalue = inptHourInvalue + inptMinInvalue;

    setBpcDate(keyInvalue);
    setBpcTime(inptTimeInvalue);
    if (setBpcTimeCd) {
      setBpcTimeCd(ampmInvalue === "오전" ? "AM" : "PM");
    }
    onCloseHandler();
  };

  const onCloseHandler = () => {
    pickerEndFn();
    // closeLayerFn($(".datetime-input-layer"));
    setIsDisplay(false);
  };

  useEffect(() => {
    setRow(toMonth, toYear, toDate, lastMonth, lastYear, week);
  }, []);

  let defaultYear = toDay.getFullYear();
  let defaultMonth = toDay.getMonth() + 1;
  let defaultDate = toDay.getDate();

  let defaultHours = toDay.getHours();
  let defaultMin = toDay.getMinutes();

  let defaultDay = week[toDay.getDay()];
  let defaultAmPm;

  if (defaultMonth < 10) {
    defaultMonth = "0" + defaultMonth;
  }

  if (defaultDate < 10) {
    defaultDate = "0" + defaultDate;
  }

  if (defaultHours < 10) {
    defaultHours = "0" + defaultHours;
  }

  if (defaultMin < 10) {
    defaultMin = "0" + defaultMin;
  }

  // 9월 28일 화 오전 08:50
  // 2022.09.28(화) 17:15
  // const defaultValue = defaultMonth + '월' + ' ' + defaultDate + '일' + ' ' + defaultDay + ' ' + defaultAmPm + ' ' + defaultHours + ':' + defaultMin;
  const defaultValue = viewDate
    ? viewDate.substring(0, 4) +
      "-" +
      viewDate.substring(4, 6) +
      "-" +
      viewDate.substring(6, 8) +
      " " +
      "(" +
      viewDay +
      ")" +
      " " +
      viewTime.substring(0, 2) +
      ":" +
      viewTime.substring(2, 4)
    : defaultYear +
      "-" +
      defaultMonth +
      "-" +
      defaultDate +
      " " +
      "(" +
      defaultDay +
      ")" +
      " " +
      defaultHours +
      ":" +
      defaultMin;

  return (
    <>
      <input
        onClick={onOpenHandler}
        type="text"
        className="textbox datetime-picker-input pick-result"
        style={{ height: "50px", lineHeight: "50px", fontSize: "0.9rem" }}
        id="mealTimeInput"
        placeholder="날짜/시간을 선택해 주세요."
        defaultValue={defaultValue}
        readOnly
      />
      {isDisplay && (
        <div className="blacklayer-container" style={{ display: "block" }}>
          <div className="bl-blind"></div>
          <div className="in-layerarea nobtn">
            <div className="blgrn-box vertical" style={{ position: "fixed" }}>
              <div className="blgr-title"></div>

              <div className="picker-container w4">
                <div className="swiper-container pickslide-date">
                  <div className="swiper-wrapper">
                    {date.map((m, i) => (
                      <div className="swiper-slide" key={i} id={m.key}>
                        <span>
                          {m.month}월 {m.date}일 {m.day}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="swiper-container pickslide-ampm">
                  <div className="swiper-wrapper">
                    <div className="swiper-slide">
                      <span>오전</span>
                    </div>
                    {/* <div className="swiper-slide">
                      <span>오후</span>
                    </div> */}

                    {(selectedDate != fullDate || parseInt(timeNow) >= 12) && (
                      <div className="swiper-slide">
                        <span>오후</span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="swiper-container pickslide-hour">
                  <div className="swiper-wrapper">
                    {
                      <TimeComponent
                        type={"hour"}
                        dateNow={selectedDate === fullDate ? true : false}
                        timeNow={
                          selectedTime.substring(0, 2) === checkNum10(timeNow).toString()
                            ? true
                            : false
                        }
                        amPmNow={amPmNow === selectedAmPm ? true : false}
                        fullDate={fullDate}
                      />
                    }
                    {/* <div className="swiper-slide">
                      <span>12</span>
                    </div> */}
                  </div>
                </div>

                <div className="swiper-container pickslide-minute">
                  <div className="swiper-wrapper">
                    {
                      <TimeComponent
                        type={"min"}
                        dateNow={selectedDate === fullDate ? true : false}
                        timeNow={
                          selectedTime.substring(0, 2).toString() === checkNum10(timeNow).toString()
                            ? true
                            : selectedAmPm === "오후"
                            ? (parseInt(selectedTime.substring(0, 2)) + 12).toString() ===
                                checkNum10(timeNow).toString() && true
                            : false
                        }
                        amPmNow={amPmNow === selectedAmPm ? true : false}
                        fullDate={fullDate}
                      />
                    }
                  </div>
                </div>
                <i className="dots"></i>
              </div>

              <div className="tbns-area">
                <a href={void 0} className="btn-round gray" onClick={onCloseHandler}>
                  취소
                </a>
                <a className="btn-round wht" onClick={onConfirmHandler}>
                  확인
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

//저장변수
let weekWhenInNum = "";
let weekHourInvalue;
let weekMinuteInvalue;
let weekInvalue = "";
let wkword = "";

//세팅 변수
let pickslideWeekWhen;
let pickslideWeekHour;
let pickslideWeekMinute;

// 슬라이드 설정 세팅(팝업 동시)
export const pickerStartFn_week = (mdcnCyclDtlCd, mdcnTime, mdcnCyclVal) => {
  // 지금시간 가져오기
  let toDay = new Date();
  let hour = toDay.getHours();
  let min = toDay.getMinutes();

  let weekWhenIdx = 0;
  let nowHourIdx = hour;
  let nowMinIdx = min;

  if (mdcnCyclDtlCd) {
    weekWhenIdx = parseInt(mdcnCyclDtlCd) - 1;
  }

  if (mdcnTime) {
    nowHourIdx = parseInt(mdcnTime.substr(0, 2));
    nowMinIdx = parseInt(mdcnTime.substr(2, 4));
  }

  $(".pick-week-area ul li a").removeClass("on");

  if (mdcnCyclVal) {
    mdcnCyclVal.split(",").map((index) => {
      $("#" + index).addClass("on");
    });
  }

  //언제
  pickslideWeekWhen = new Swiper(".pickslide-week-when", {
    // Optional parameters
    direction: "vertical",
    slidesPerView: 5,
    centeredSlides: true,
    initialSlide: weekWhenIdx,
    on: {
      init: function () {
        weekWhenInNum = $(".pickslide-week-when .swiper-slide-active span").attr("name");
      },
      slideChangeTransitionEnd: function () {
        weekWhenInNum = $(".pickslide-week-when .swiper-slide-active span").attr("name");
      },
    },
  });

  //시
  pickslideWeekHour = new Swiper(".pickslide-week-hour", {
    // Optional parameters
    direction: "vertical",
    loop: true,
    slidesPerView: 5,
    centeredSlides: true,
    initialSlide: nowHourIdx,
    on: {
      slideChangeTransitionEnd: function () {
        weekHourInvalue = $(".pickslide-week-hour .swiper-slide-active span").html();
      },
    },
  });

  //분
  pickslideWeekMinute = new Swiper(".pickslide-week-minute", {
    // Optional parameters
    direction: "vertical",
    loop: true,
    slidesPerView: 5,
    centeredSlides: true,
    initialSlide: nowMinIdx,
    on: {
      slideChangeTransitionEnd: function () {
        weekMinuteInvalue = $(".pickslide-week-minute .swiper-slide-active span").html();
      },
    },
  });
};

//슬라이드 설정 해제(팝업 닫기 직전)
const pickerEndFn_week = () => {
  pickslideWeekWhen.destroy();
  pickslideWeekHour.destroy();
  pickslideWeekMinute.destroy();
};

export const rendering = (goal, gap) => {
  const result = [];

  for (let i = 0; i < goal; i = i + gap) {
    result.push(
      <div className="swiper-slide" key={i}>
        <span>{checkNum10(i)}</span>
      </div>
    );
  }

  return result;
};

export const WeekTimeLayer = (props) => {
  const { handleDate } = props;

  useEffect(() => {
    //상단 요일 선택
    $(".pick-week-area ul li a").click(function () {
      $(this).toggleClass("on");
    });

    //닫기
    $(".week-set-layer .tbns-area a").click(function () {
      //확인버튼일 경우 저장 세팅
      if ($(this).hasClass("wht")) {
        $(".pick-week-area ul li").each(function () {
          //요일선택
          if ($(this).find("a").hasClass("on")) {
            wkword = $(this).find("a.on").attr("id") + ",";
            weekInvalue += wkword;
          }
        });
        weekInvalue = weekInvalue.substr(0, weekInvalue.length - 1);
        handleDate("02", weekInvalue, weekWhenInNum, weekHourInvalue + weekMinuteInvalue);
      }
      weekInvalue = "";
      pickerEndFn_week();
      closeLayerFn($(".week-set-layer"));
    });
  }, []);
  return (
    <div className="blacklayer-container week-set-layer">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div className="blgrn-box vertical">
          <div className="blgr-title">복약시간 설정</div>

          <div className="pick-week-area">
            <ul>
              <li>
                <a id="1">일</a>
              </li>
              <li>
                <a id="2">월</a>
              </li>
              <li>
                <a id="3">화</a>
              </li>
              <li>
                <a id="4">수</a>
              </li>
              <li>
                <a id="5">목</a>
              </li>
              <li>
                <a id="6">금</a>
              </li>
              <li>
                <a id="7">토</a>
              </li>
            </ul>
          </div>

          <div className="picker-container w3r">
            <div className="swiper-container pickslide-week-when">
              <div className="swiper-wrapper">
                <div className="swiper-slide">
                  <span name="01">아침식전</span>
                </div>
                <div className="swiper-slide">
                  <span name="02">아침</span>
                </div>
                <div className="swiper-slide">
                  <span name="03">점심</span>
                </div>
                <div className="swiper-slide">
                  <span name="04">저녁</span>
                </div>
                <div className="swiper-slide">
                  <span name="05">잠자기전</span>
                </div>
              </div>
            </div>

            <div className="swiper-container pickslide-week-hour">
              <div className="swiper-wrapper">{rendering(23, 1)}</div>
            </div>

            <div className="swiper-container pickslide-week-minute">
              <div className="swiper-wrapper">{rendering(60, 1)}</div>
            </div>
            <i className="dots"></i>
          </div>

          <div className="tbns-area">
            <a className="btn-round gray">취소</a>
            <a className="btn-round wht check-week-on">확인</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export const AfterMealInputLayer = (props) => {
  const { setAfMealTime } = props;

  useEffect(() => {
    $(".aftermeal-input-layer .tbns-area a").click(function () {
      //확인버튼일 경우 선택값 적용
      if ($(this).hasClass("wht")) {
        let hourInvalue = $(".pickslide-afhour .swiper-slide-active span").html();
        let minInvalue = $(".pickslide-afminute .swiper-slide-active span").html();
        setAfMealTime(hourInvalue + minInvalue);
        $(".pick-result2").val(
          $(".pickslide-after .swiper-slide-active span").html() +
            " " +
            hourInvalue +
            ":" +
            minInvalue
        );
      }
      pickerEndFn2();
      closeLayerFn($(".aftermeal-input-layer"));
    });
  }, []);

  return (
    <div className="blacklayer-container aftermeal-input-layer">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div className="blgrn-box vertical">
          <div className="blgr-title">일시 설정</div>

          <div className="picker-container w3">
            <div className="swiper-container pickslide-after">
              <div className="swiper-wrapper">
                <div className="swiper-slide">
                  <span className="meal-txt">식사 전</span>
                </div>
              </div>
            </div>

            <div className="swiper-container pickslide-afhour">
              <div className="swiper-wrapper">{rendering(13, 1)}</div>
            </div>

            <div className="swiper-container pickslide-afminute">
              <div className="swiper-wrapper">{rendering(60, 5)}</div>
            </div>
            <i className="dots"></i>
          </div>

          <div className="tbns-area">
            <a href={void 0} className="btn-round gray">
              취소
            </a>
            <a href={void 0} className="btn-round wht">
              확인
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export const AfterMealInputLayerMod = (props) => {
  const { afMealTime, setAfMealTime, mealType, targetData } = props;
  const [isDisplay, setIsDisplay] = useState(false);

  const onOpenHandler = async () => {
    await new Promise((resolve) => {
      resolve(setIsDisplay(true));
    });

    pickerStartFn2(targetData);
  };

  const onCloseHandler = async () => {
    setAfMealTime(afterHourInvalue + afterMinuteInvalue);
    await new Promise((resolve) => {
      resolve(setIsDisplay(false));
    });
  };

  return (
    <Fragment>
      <div
        style={{
          width: "100%",
          height: "40px",
          lineHeight: "40px",
          background: "#fff",
          borderRadius: "8px",
          marginTop: "14px",
          textAlign: "left",
          padding: "5px 15px",
        }}
        onClick={onOpenHandler}
      >
        {afMealTime && afMealTime != "undefined"
          ? "식후 " + afMealTime.substring(0, 2) + ":" + afMealTime.substring(2, 4)
          : props.targetData.column3.split(" ").length == 2 &&
            props.targetData.column3.split(" ")[1] != ""
          ? props.targetData.column3
          : "식후 02:00"}
      </div>

      {isDisplay && (
        <div className="blacklayer-container aftermeal-input-layer" style={{ display: "block" }}>
          <div className="bl-blind"></div>
          <div className="in-layerarea nobtn">
            <div className="blgrn-box vertical" style={{ position: "fixed" }}>
              <div className="blgr-title">일시 설정</div>

              <div className="picker-container w3">
                <div className="swiper-container pickslide-after">
                  <div className="swiper-wrapper">
                    <div className="swiper-slide">
                      <span className="meal-txt">식후</span>
                    </div>
                  </div>
                </div>

                <div className="swiper-container pickslide-afhour">
                  <div className="swiper-wrapper">{rendering(13, 1)}</div>
                </div>

                <div className="swiper-container pickslide-afminute">
                  <div className="swiper-wrapper">{rendering(60, 5)}</div>
                </div>
                <i className="dots"></i>
              </div>

              <div className="tbns-area">
                <a
                  className="btn-round gray"
                  onClick={() => {
                    // pickerEndFn2();
                    setIsDisplay(false);
                  }}
                >
                  취소
                </a>
                <a className="btn-round wht" onClick={onCloseHandler}>
                  확인
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};
// 식사시간 + 시간 + 분 (매일)
// 슬라이드 설정 세팅(팝업 동시)

//저장변수
var dayWhenInNum;
var dayHourInvalue;
var dayMinuteInvalue;

//세팅변수
let pickslideDayWhen;
let pickslideDayHour;
let pickslideDayMinute;

export const pickerStartFn_day = (mdcnCyclDtlCd, mdcnTime) => {
  // 지금시간 가져오기
  let toDay = new Date();
  let hour = toDay.getHours();
  let min = toDay.getMinutes();

  let dayWhenIdx = 0;
  let nowHourIdx = hour;
  let nowMinIdx = min;

  if (mdcnCyclDtlCd) {
    dayWhenIdx = parseInt(mdcnCyclDtlCd.substr(1, 2) - 1);
  }

  if (mdcnTime) {
    nowHourIdx = parseInt(mdcnTime.substr(0, 2));
    nowMinIdx = parseInt(mdcnTime.substr(2, 4));
  }

  //언제
  pickslideDayWhen = new Swiper(".pickslide-day-when", {
    // Optional parameters
    direction: "vertical",
    loop: true,
    slidesPerView: 5,
    centeredSlides: true,
    initialSlide: dayWhenIdx,
    on: {
      slideChangeTransitionEnd: function () {
        // dayWhenInNum = $(".pickslide-day-when .swiper-slide-active span").html();
        dayWhenInNum = $(".pickslide-day-when .swiper-slide-active span").attr("name");
      },
    },
  });

  //시
  pickslideDayHour = new Swiper(".pickslide-day-hour", {
    // Optional parameters
    direction: "vertical",
    loop: true,
    slidesPerView: 5,
    centeredSlides: true,
    initialSlide: nowHourIdx,
    on: {
      slideChangeTransitionEnd: function () {
        dayHourInvalue = $(".pickslide-day-hour .swiper-slide-active span").html();
      },
    },
  });

  //분
  pickslideDayMinute = new Swiper(".pickslide-day-minute", {
    // Optional parameters
    direction: "vertical",
    loop: true,
    slidesPerView: 5,
    centeredSlides: true,
    initialSlide: nowMinIdx,
    on: {
      slideChangeTransitionEnd: function () {
        dayMinuteInvalue = $(".pickslide-day-minute .swiper-slide-active span").html();
      },
    },
  });
};

//슬라이드 설정 해제(팝업 닫기 직전)
const pickerEndFn_day = () => {
  pickslideDayWhen.destroy();
  pickslideDayHour.destroy();
  pickslideDayMinute.destroy();
};

export const EveryDayTimeLayer = (props) => {
  const { handleDate } = props;

  useEffect(() => {
    //닫기
    $(".day-set-layer .tbns-area a").click(function () {
      //확인버튼일 경우 저장 세팅
      if ($(this).hasClass("wht")) {
        handleDate("01", "", dayWhenInNum, dayHourInvalue + dayMinuteInvalue);
      }

      closeLayerFn($(".day-set-layer"));
      pickerEndFn_day();
    });
  }, []);

  return (
    <div className="blacklayer-container day-set-layer">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div className="blgrn-box vertical">
          <div className="blgr-title">복약시간 설정</div>

          <div className="picker-container repad w3r">
            <div className="swiper-container pickslide-day-when">
              <div className="swiper-wrapper">
                <div className="swiper-slide">
                  <span name="01">아침식사전</span>
                </div>
                <div className="swiper-slide">
                  <span name="02">아침</span>
                </div>
                <div className="swiper-slide">
                  <span name="03">점심</span>
                </div>
                <div className="swiper-slide">
                  <span name="04">저녁</span>
                </div>
                <div className="swiper-slide">
                  <span name="05">잠자기전</span>
                </div>
              </div>
            </div>

            <div className="swiper-container pickslide-day-hour">
              <div className="swiper-wrapper">{rendering(24, 1)}</div>
            </div>

            <div className="swiper-container pickslide-day-minute">
              <div className="swiper-wrapper">{rendering(60, 1)}</div>
            </div>
            <i className="dots"></i>
          </div>

          <div className="tbns-area">
            <a className="btn-round gray">취소</a>
            <a className="btn-round wht check-day-on">확인</a>
          </div>
        </div>
      </div>
    </div>
  );
};

// 날짜 + 식사시간 + 시간 + 분 (매월)
//저장변수
let monthWeekInNum;
let monthWhenInNum;
let monthHourInvalue;
let monthMinuteInvalue;
//세팅 변수
let pickslideMonthWeek;
let pickslideMonthWhen;
let pickslideMonthHour;
let pickslideMonthMinute;

// 슬라이드 설정 세팅(팝업 동시)
export const pickerStartFn_month = (mdcnCyclDtlCd, mdcnTime, mdcnCyclVal) => {
  // 지금시간 가져오기
  let toDay = new Date();
  let hour = toDay.getHours();
  let min = toDay.getMinutes();
  let date = toDay.getDate();

  let whenIdx = 0;
  let nowHourIdx = hour;
  let nowMinIdx = min;
  let nowDateIdx = date - 1;

  if (mdcnCyclDtlCd) {
    whenIdx = parseInt(mdcnCyclDtlCd) - 1;
  }

  if (mdcnTime) {
    nowHourIdx = parseInt(mdcnTime.substr(0, 2));
    nowMinIdx = parseInt(mdcnTime.substr(2, 4));
  }

  if (mdcnCyclVal) {
    nowDateIdx = parseInt(mdcnCyclVal) - 1;
  }

  //일
  pickslideMonthWeek = new Swiper(".pickslide-month-day", {
    // Optional parameters
    direction: "vertical",
    loop: true,
    slidesPerView: 5,
    centeredSlides: true,
    initialSlide: nowDateIdx,
    on: {
      slideChangeTransitionEnd: function () {
        monthWeekInNum = $(".pickslide-month-day .swiper-slide-active span").attr("name");
      },
    },
  });

  //언제
  pickslideMonthWhen = new Swiper(".pickslide-month-when", {
    // Optional parameters
    direction: "vertical",
    loop: true,
    slidesPerView: 5,
    centeredSlides: true,
    initialSlide: whenIdx,
    on: {
      slideChangeTransitionEnd: function () {
        monthWhenInNum = $(".pickslide-month-when .swiper-slide-active span").attr("name");
      },
    },
  });

  //시
  pickslideMonthHour = new Swiper(".pickslide-month-hour", {
    // Optional parameters
    direction: "vertical",
    loop: true,
    slidesPerView: 5,
    centeredSlides: true,
    initialSlide: nowHourIdx,
    on: {
      slideChangeTransitionEnd: function () {
        monthHourInvalue = $(".pickslide-month-hour .swiper-slide-active span").html();
      },
    },
  });

  //분
  pickslideMonthMinute = new Swiper(".pickslide-month-minute", {
    // Optional parameters
    direction: "vertical",
    loop: true,
    slidesPerView: 5,
    centeredSlides: true,
    initialSlide: nowMinIdx,
    on: {
      slideChangeTransitionEnd: function () {
        monthMinuteInvalue = $(".pickslide-month-minute .swiper-slide-active span").html();
      },
    },
  });
};

//슬라이드 설정 해제(팝업 닫기 직전)
const pickerEndFn_month = () => {
  pickslideMonthWeek.destroy();
  pickslideMonthWhen.destroy();
  pickslideMonthHour.destroy();
  pickslideMonthMinute.destroy();
};

export const MonthDateLayer = (props) => {
  const { handleDate } = props;

  const toDay = new Date();
  let toMonthData = toDay.getMonth() + 1;

  if (toMonthData < 10) {
    toMonthData = "0" + toMonthData.toString();
  }

  const [toYear, setToYear] = useState(toDay.getFullYear().toString());
  const [toMonth, setToMonth] = useState(toMonthData);
  const [toDate, setToDate] = useState(toDay.getDate());

  // setState를 위한 배열
  let dateArr = [];

  // .map을 위한 배열 State
  const [date, setDate] = useState([]);

  const settingDate = () => {
    // 1일~최대일
    for (let i = 1; i <= lastDate; i++) {
      if (i < 10) {
        dateArr.push("0" + i);
      } else {
        dateArr.push(i);
      }
    }
    setDate(dateArr);
  };

  const settingLastDate = (toYear, toMonth) => {
    lastDate = new Date(toYear, toMonth, 0).getDate();
    settingDate();
  };

  useEffect(() => {
    //닫기
    $(".month-set-layer .tbns-area a").click(function () {
      //확인버튼일 경우 저장 세팅
      if ($(this).hasClass("wht")) {
        handleDate("03", monthWeekInNum, monthWhenInNum, monthHourInvalue + monthMinuteInvalue);
      }
      closeLayerFn($(".month-set-layer"));
      pickerEndFn_month();
    });

    settingLastDate(toYear, toMonth);
  }, []);

  return (
    <div className="blacklayer-container month-set-layer">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div className="blgrn-box vertical">
          <div className="blgr-title">복약시간 설정</div>

          <div className="picker-container w4p">
            <div className="swiper-container pickslide-month-day">
              <div className="swiper-wrapper">
                <SettingDate date={date} toYear={toYear} toMonth={toMonth} />
              </div>
            </div>

            <div className="swiper-container pickslide-month-when">
              <div className="swiper-wrapper">
                <div className="swiper-slide">
                  <span name="01">아침식사전</span>
                </div>
                <div className="swiper-slide">
                  <span name="02">아침</span>
                </div>
                <div className="swiper-slide">
                  <span name="03">점심</span>
                </div>
                <div className="swiper-slide">
                  <span name="04">저녁</span>
                </div>
                <div className="swiper-slide">
                  <span name="05">잠자기전</span>
                </div>
              </div>
            </div>

            <div className="swiper-container pickslide-month-hour">
              <div className="swiper-wrapper">{rendering(24, 1)}</div>
            </div>

            <div className="swiper-container pickslide-month-minute">
              <div className="swiper-wrapper">{rendering(60, 1)}</div>
            </div>
            <i className="dots"></i>
          </div>

          <div className="tbns-area">
            <a className="btn-round gray">취소</a>
            <a className="btn-round wht check-month-on">확인</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export const BrowsePopup = () => {
  useEffect(() => {
    //다운로드 가능 기간이 지났습니다. //열기
    $(".btn-history-alert").click(function () {
      openLayerFn($(".history-alert-layer"));
    });
    //닫기
    $(".history-alert-layer .tbns-area a").click(function () {
      closeLayerFn($(".history-alert-layer"));
    });
  }, []);
  return (
    <div className="blacklayer-container history-alert-layer ">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div>
          <div className="blgrn-box vertical priv">
            <div className="blgr-title">기록 열람</div>

            <div className="save-question-box">다운로드 가능 기간이 지났습니다.</div>

            <div className="tbns-area">
              <a className="btn-round wht">확인</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const initLayout = (auth) => {
  // 초기화
  $(".btn-myset").off("click");
  $(".btn-menulines").off("click");
  $(".side-menu-container .smc-blind").off("click");
  $(".btn-setlayer-close").off("click");
  $(".select-custom-box a.btn-select").off("click");
  $(".select-custom-box ul li a").off("click");
  $("body").off("click");

  //좌측 메뉴 토글
  $(".btn-menulines").click(function () {
    if (!$(".side-menu-container").hasClass("open")) {
      //열기
      sideMenuOpen();
    } else {
      //닫기
      sideMenuClose();
    }
  });

  //여백 눌러도 닫기
  $(".side-menu-container .smc-blind").click(function () {
    sideMenuClose();
  });

  $(".btn-myset").click(function () {
    if (!auth) {
      _O.OpenMenu("/membership/login");
    }
    // openLayerFn($(".myhealth-manage-layer"));
    openLayerFn($(".myhealth-cards-layer"));
  });

  // MY건강관리 목록 세팅 레이어 닫기
  $(".btn-setlayer-close").click(function () {
    closeLayerFn($(".myhealth-manage-layer"));
  });

  if ($(".select-custom-box").length > 0) {
    $(".select-custom-box a.btn-select").click(function () {
      if ($(".select-custom-box").hasClass("on")) {
        $(".select-custom-box").removeClass("on");
      } else {
        $(this).parent().toggleClass("on");
      }
    });

    $(".select-custom-box ul li a").click(function () {
      $(this).closest(".select-custom-box").removeClass("on");
      $(this).closest(".select-custom-box").find("a.btn-select").html($(this).html());
    });

    $("body").click(function (e) {
      if ($(".select-custom-box").hasClass("on")) {
        if (!$(".select-custom-box").has(e.target).length) {
          $(".select-custom-box").removeClass("on");
        }
      }
    });
  }
};

/////////////// 사이드 메뉴
const sideMenuOpen = () => {
  $(".contents-container").addClass("fix");
  $(".btn-menulines").addClass("active");

  $(".side-menu-container").show();
  $(".contents-container").addClass("blur");
  setTimeout(() => {
    $(".side-menu-container").addClass("open");
  }, 100);
};

const sideMenuClose = () => {
  $(".btn-menulines").removeClass("active");

  setTimeout(() => {
    $(".side-menu-container").removeClass("open");
  }, 100);

  setTimeout(() => {
    $(".side-menu-container").hide();
    $(".contents-container").removeClass("blur");

    $(".contents-container").removeClass("fix");
  }, 100);
};

let setScrollDist = 0;
export const openLayerFn = (target) => {
  setScrollDist = $(window).scrollTop();
  $(".btn-menulines").addClass("ndel blur"); //좌측상단 삼선버튼(별도효과)
  $(".contents-container").addClass("fix blur");
  $(".contents-container").css("top", -setScrollDist);
  $(".fix-area > div").addClass("blur");

  if ($("a.btn-backpage").length > 0) {
    $("a.btn-backpage").css("top", -setScrollDist);
  }

  if (!target) {
    $(".blacklayer-container").show();
  } else {
    target.show();
  }
};

export const closeLayerFn = (target) => {
  if (!target) {
    $(".blacklayer-container").hide();
  } else {
    target.hide();
  }

  //좌측상단 삼선버튼(별도효과)
  $(".btn-menulines").removeClass("blur");
  setTimeout(function () {
    $(".btn-menulines").removeClass("ndel");
  }, 205);

  $(".contents-container").removeClass("fix blur");
  $(".contents-container").removeAttr("style");
  $(".fix-area > div").removeClass("blur");

  if ($("a.btn-backpage").length > 0) {
    $("a.btn-backpage").removeAttr("style");
  }

  $(window).scrollTop(setScrollDist);
};

export const pickerStart = (setToYear, setToMonth, toYearIdx, toMonth, toDate, setToDate) => {
  let toYearIdxData = parseInt(toYearIdx - (new Date().getFullYear() - 10));

  if (toYearIdx === 0) {
    toYearIdxData = 10;
  }
  //일시 설정 레이어 스크롤링 스크립트
  //년
  pickslideYear = new Swiper(".pickslide-year", {
    // Optional parameters
    direction: "vertical",
    loop: false,
    slidesPerView: 5,
    centeredSlides: true,
    initialSlide: toYearIdxData,
    // initialSlide: 1,
    longSwipesMs: 100,
    on: {
      slideChangeTransitionEnd: function () {
        yearInvalue = $(".pickslide-year .swiper-slide-active span").html();
        setToYear(yearInvalue.substring(0, 4));
      },
    },

    observer: true,
    observeParents: true,
    observeSlideChildren: true,
  });

  //월
  // if (parseInt(toMonth) === 1) {
  // console.log("toMonth가 1임");
  monthInvalue = checkNum10(toMonth) + "월";
  setToMonth(monthInvalue.substring(0, 2));
  // }

  pickslideMonth = new Swiper(".pickslide-month", {
    // Optional parameters
    direction: "vertical",
    loop: false,
    slidesPerView: 5,
    centeredSlides: true,
    initialSlide: parseInt(toMonth) - 1,
    // initialSlide: parseInt(toMonth) - 1,
    longSwipesMs: 100,

    on: {
      slideChangeTransitionEnd: function () {
        monthInvalue = $(".pickslide-month .swiper-slide-active span").html();
        setToMonth(monthInvalue.substring(0, 2));
      },

      slidesLengthChange: function () {
        // monthInvalue = $(".pickslide-month .swiper-slide-active span").html();
        if ($(".pickslide-month .swiper-slide-active span").length > 0) {
          setToMonth(monthInvalue.substring(0, 2));
        } else {
          setToMonth("01");
        }
      },
    },

    // 스타일을 변경하거나 하위 요소를 수정할 떄마다 swiper 초기화
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
  });

  //일
  if (toDate === 1) {
    dayInvalue = checkNum10(toDate) + "일";
  }

  pickslideDay = new Swiper(".pickslide-day", {
    // Optional parameters
    direction: "vertical",
    // loop: true,
    slidesPerView: 5,
    centeredSlides: true,
    initialSlide: toDate - 1,
    longSwipesMs: 100,

    on: {
      slideChangeTransitionEnd: function () {
        dayInvalue = $(".pickslide-day .swiper-slide-active span").html();
        setToDate(dayInvalue);
      },

      init: function () {
        dayInvalue = $(".pickslide-day .swiper-slide-active span").html();
        if (setToDate) {
          setToDate(dayInvalue);
        }
      },
    },
    // 스타일을 변경하거나 하위 요소를 수정할 떄마다 swiper 초기화
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
  });
};

export const pickerStartHist = (setToYear, setToMonth, toYearIdx, toMonth, toDate) => {
  //일시 설정 레이어 스크롤링 스크립트
  //년
  pickslideYear = new Swiper(".pickslide-year", {
    // Optional parameters
    direction: "vertical",
    loop: true,
    // slidesPerView: 5,
    slidesPerView: 5,
    centeredSlides: true,
    initialSlide: 5 - toYearIdx,
    longSwipesMs: 100,
    on: {
      slideChangeTransitionEnd: function () {
        yearInvalue = $(".pickslide-year .swiper-slide-active span").html();
        setToYear(yearInvalue.substring(0, 4));
      },
    },

    observer: true,
    observeParents: true,
    observeSlideChildren: true,
  });

  //월
  pickslideMonth = new Swiper(".pickslide-month", {
    // Optional parameters
    direction: "vertical",
    loop: true,
    slidesPerView: 5,
    centeredSlides: true,
    initialSlide: toMonth - 1,
    longSwipesMs: 100,

    on: {
      slideChangeTransitionEnd: function () {
        monthInvalue = $(".pickslide-month .swiper-slide-active span").html();
        setToMonth(monthInvalue.substring(0, 2));
      },
    },

    // 스타일을 변경하거나 하위 요소를 수정할 떄마다 swiper 초기화
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
  });

  //일
  pickslideDay = new Swiper(".pickslide-day", {
    // Optional parameters
    direction: "vertical",
    // loop: true,
    slidesPerView: 5,
    centeredSlides: true,
    initialSlide: toDate - 1,
    longSwipesMs: 100,

    on: {
      slideChangeTransitionEnd: function () {
        dayInvalue = $(".pickslide-day .swiper-slide-active span").html();
      },
    },
    // 스타일을 변경하거나 하위 요소를 수정할 떄마다 swiper 초기화
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
  });
};

// 슬라이드 설정 세팅(팝업 동시)
export const pickerStartFn = (
  date,
  selectedDate,
  setSelectedDate,
  selectedTime,
  setSelectedTime,
  selectedMin,
  setSelectedMin,
  selectedAmPm,
  setSelectedAmPm,
  realIdx,
  setRealIdx
) => {
  let initialIndex;
  if (!date) {
    initialIndex = 0;
  } else {
    initialIndex = date.length - 1;
  }

  // 지금시간 가져오기
  let toDay = new Date();
  let hour = toDay.getHours();
  let min = toDay.getMinutes();

  let nowHourIdx = hour - 1;
  let nowMinIdx = min;
  let nowAmPmIdx = 0;

  // 사간이 12시 이상인경우 am/pm 나누기
  if (hour > 12) {
    nowAmPmIdx = 1;
    nowHourIdx = nowHourIdx - 11;
  }
  // 최초 세팅
  keyInvalue = $(".pickslide-date .swiper-slide-active").attr("id");

  //날짜
  pickslideDate = new Swiper(".pickslide-date", {
    // Optional parameters
    direction: "vertical",
    loop: true,
    slidesPerView: 5,
    centeredSlides: true,
    initialSlide: realIdx,

    // 스타일을 변경하거나 하위 요소를 수정할 떄마다 swiper 초기화
    observer: true,
    observeParents: true,

    on: {
      slideChangeTransitionEnd: function () {
        dateInvalue = $(".pickslide-date .swiper-slide-active span").html();
        keyInvalue = $(".pickslide-date .swiper-slide-active").attr("id");
        setSelectedDate($(".pickslide-date .swiper-slide-active").attr("id"));
      },
    },
  });

  //오전오후
  pickslideAmpm = new Swiper(".pickslide-ampm", {
    // Optional parameters
    direction: "vertical",
    //loop: true,
    slidesPerView: 5,
    initialSlide: selectedAmPm === "오후" ? 1 : 0,
    centeredSlides: true,

    // 스타일을 변경하거나 하위 요소를 수정할 떄마다 swiper 초기화
    observer: true,
    observeParents: true,

    on: {
      init: function () {
        ampmInvalue = $(".pickslide-ampm .swiper-slide-active span").html();
        setSelectedAmPm($(".pickslide-ampm .swiper-slide-active span").html());
      },
      slideChangeTransitionEnd: function () {
        ampmInvalue = $(".pickslide-ampm .swiper-slide-active span").html();
        setSelectedAmPm($(".pickslide-ampm .swiper-slide-active span").html());
      },

      observerUpdate: function () {
        ampmInvalue = $(".pickslide-ampm .swiper-slide-active span").html();
        setSelectedAmPm($(".pickslide-ampm .swiper-slide-active span").html());
      },
    },
  });

  //시
  let initialTime = parseInt(selectedTime.substring(0, 2));
  if (initialTime > 11) {
    initialTime = initialTime - 12;
  }
  pickslideHour = new Swiper(".pickslide-hour", {
    // Optional parameters
    direction: "vertical",
    // loop: false,
    slidesPerView: 5,
    // initialSlide: nowHourIdx,
    initialSlide: initialTime,
    // initialSlide: initialTime - 1,
    centeredSlides: true,

    observer: true,
    observeParents: true,
    on: {
      slideChangeTransitionEnd: function () {
        hourInvalue = $(".pickslide-hour .swiper-slide-active span").html();
        setSelectedTime($(".pickslide-hour .swiper-slide-active span").html());
      },

      init: function () {
        // do something
        hourInvalue = $(".pickslide-hour .swiper-slide-active span").html();
        setSelectedTime($(".pickslide-hour .swiper-slide-active span").html());
      },

      // activeIndexChange: function () {
      //   console.log("activeIndexChange");
      // },

      observerUpdate: function () {
        hourInvalue = $(".pickslide-hour .swiper-slide-active span").html();
        setSelectedTime($(".pickslide-hour .swiper-slide-active span").html());
      },
    },
  });

  //분
  let initialMin = parseInt(selectedMin);
  pickslideMinute = new Swiper(".pickslide-minute", {
    // Optional parameters
    direction: "vertical",
    // loop: true,
    slidesPerView: 5,
    // initialSlide: nowMinIdx,
    initialSlide: initialMin,
    centeredSlides: true,

    // 스타일을 변경하거나 하위 요소를 수정할 떄마다 swiper 초기화
    observer: true,
    observeParents: true,

    on: {
      slideChangeTransitionEnd: function () {
        minuteInvalue = $(".pickslide-minute .swiper-slide-active span").html();
        inptMinInvalue = $(".pickslide-minute .swiper-slide-active span").html();
        setSelectedMin($(".pickslide-minute .swiper-slide-active span").html());
      },

      init: function () {
        // do something
        minuteInvalue = $(".pickslide-minute .swiper-slide-active span").html();
        inptMinInvalue = $(".pickslide-minute .swiper-slide-active span").html();
        setSelectedMin($(".pickslide-minute .swiper-slide-active span").html());
      },

      observerUpdate: function () {
        minuteInvalue = $(".pickslide-minute .swiper-slide-active span").html();
        inptMinInvalue = $(".pickslide-minute .swiper-slide-active span").html();
        setSelectedMin($(".pickslide-minute .swiper-slide-active span").html());
      },
    },
  });
};

//슬라이드 설정 해제(팝업 닫기 직전)
export const pickerEndFn = () => {
  try {
    pickslideDate.destroy();
  } catch (e) {}
  try {
    pickslideAmpm.destroy();
  } catch (e) {}
  try {
    pickslideHour.destroy();
  } catch (e) {}
  try {
    pickslideMinute.destroy();
  } catch (e) {}
  try {
    pickslideYear.destroy();
  } catch (e) {}
  try {
    pickslideMonth.destroy();
  } catch (e) {}
  try {
    pickslideDay.destroy();
  } catch (e) {}
  try {
    pickslideDate.destroy();
  } catch (e) {}
};

let afterInvalue;
let afterHourInvalue;
let afterMinuteInvalue;
let pickslideAfter;
let pickslideAfHour;
let pickslideAfMinute;

// 슬라이드 설정 세팅(팝업 동시)
export const pickerStartFn2 = (targetData) => {
  const afHour =
    targetData && targetData.column3.split(" ")[1]
      ? parseInt(targetData.column3.split(" ")[1].split(":")[0])
      : 2;
  const afMin =
    targetData && targetData.column3.split(" ")[1]
      ? parseInt(targetData.column3.split(" ")[1].split(":")[1])
      : 0;
  //식사후
  pickslideAfter = new Swiper(".pickslide-after", {
    // Optional parameters
    direction: "vertical",
    // loop: true,
    slidesPerView: 5,
    centeredSlides: true,

    on: {
      init: function () {
        afterInvalue = $(".pickslide-after .swiper-slide-active span").html();
      },
      slideChangeTransitionEnd: function () {
        afterInvalue = $(".pickslide-after .swiper-slide-active span").html();
      },
    },

    // 스타일을 변경하거나 하위 요소를 수정할 떄마다 swiper 초기화
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
  });

  //시
  pickslideAfHour = new Swiper(".pickslide-afhour", {
    // Optional parameters
    direction: "vertical",
    loop: true,
    slidesPerView: 5,
    centeredSlides: true,
    // initialSlide: 2,
    initialSlide: afHour,

    on: {
      slideChangeTransitionEnd: function () {
        afterHourInvalue = $(".pickslide-afhour .swiper-slide-active span").html();
      },
    },

    // 스타일을 변경하거나 하위 요소를 수정할 떄마다 swiper 초기화
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
  });

  //분
  pickslideAfMinute = new Swiper(".pickslide-afminute", {
    // Optional parameters
    direction: "vertical",
    loop: true,
    slidesPerView: 5,
    initialSlide: afMin / 5,
    // slidesPerView: (afMin/5)+5,
    centeredSlides: true,

    on: {
      slideChangeTransitionEnd: function () {
        afterMinuteInvalue = $(".pickslide-afminute .swiper-slide-active span").html();
      },
    },

    // 스타일을 변경하거나 하위 요소를 수정할 떄마다 swiper 초기화
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
  });
};

//슬라이드 설정 해제(팝업 닫기 직전)
export const pickerEndFn2 = () => {
  pickslideAfter.destroy();
  pickslideAfHour.destroy();
  pickslideAfMinute.destroy();
};

let mediInvalueName;
let mediInvalueIUml;
let numberInvalue;

let pickslideMedi;
let pickslideNumber;

let injctCode;

// 슬라이드 설정 세팅(팝업 동시)
export const pickerStartInsFn = () => {
  //약 이름
  // pickslideMedi = new Swiper(".pickslide-medi", {
  //     // Optional parameters
  //     direction: "vertical",
  //     loop: true,
  //     slidesPerView: 5,
  //     centeredSlides: true,
  //     on: {
  //         slideChangeTransitionEnd: function () {
  //             mediInvalueName = $(".pickslide-medi .swiper-slide-active span u").html();
  //             mediInvalueIUml = $(".pickslide-medi .swiper-slide-active span em").html();

  //             injctCode = $(".pickslide-medi .swiper-slide-active span").attr("id");

  //         },
  //     },
  // });

  //수치
  pickslideNumber = new Swiper(".pickslide-number", {
    // Optional parameters
    direction: "vertical",
    loop: true,
    slidesPerView: 5,
    centeredSlides: true,

    // 스타일을 변경하거나 하위 요소를 수정할 떄마다 swiper 초기화
    observer: true,
    observeParents: true,

    on: {
      slideChangeTransitionEnd: function () {
        numberInvalue = $(".pickslide-number .swiper-slide-active span").html();
      },
    },
  });
};

//슬라이드 설정 해제(팝업 닫기 직전)
export const pickerEndInsFn = () => {
  try {
    pickslideMedi.destroy();
  } catch (e) {}
  try {
    pickslideNumber.destroy();
  } catch (e) {}
};

export const InsulinLayer = (props) => {
  const { setInjctForm, setInjctDose } = props;
  useEffect(() => {
    $(".insulin-set-layer .tbns-area a").click(function () {
      //확인버튼일 경우 선택값 적용
      if ($(this).hasClass("wht")) {
        $(".gradation-box .in-txt span").html(mediInvalueName);
        $(".gradation-box .in-txt u").html(mediInvalueIUml);
        $(".gradation-box .nums .center").html(numberInvalue);

        if (numberInvalue === "15") {
          $(".gradation-box .nums .prev").html(14);
          $(".gradation-box .nums .next").html(1);
        } else if (numberInvalue === "1") {
          $(".gradation-box .nums .prev").html(15);
          $(".gradation-box .nums .next").html(2);
        } else {
          $(".gradation-box .nums .prev").html(parseInt(numberInvalue) - 1);
          $(".gradation-box .nums .next").html(parseInt(numberInvalue) + 1);
        }

        setInjctForm(injctCode);
        setInjctDose(numberInvalue);
      }

      pickerEndInsFn();
      closeLayerFn($(".insulin-set-layer"));
    });
  }, []);

  return (
    <div className="blacklayer-container insulin-set-layer">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div className="blgrn-box vertical">
          <div className="blgr-title">인슐린 투약</div>

          <div className="white-tbox">
            처방투약 용량 <b> 인슐린 10단위</b>
          </div>

          <div className="picker-container w2os">
            {/* <div className="swiper-container pickslide-medi">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide">
                                    <span id="01">
                                        <u>초속효성</u> <em>(식전 15분전, 직전)</em>
                                    </span>
                                </div>
                                <div className="swiper-slide">
                                    <span id="02">
                                        <u>중간형</u> <em>(식사 30분 전)</em>
                                    </span>
                                </div>
                                <div className="swiper-slide">
                                    <span id="03">
                                        <u>혼합형</u> <em>(식전 15분전, 직전)</em>
                                    </span>
                                </div>
                                <div className="swiper-slide">
                                    <span id="04">
                                        <u>장시간형</u> <em>(하루 한번 같은 시간)</em>
                                    </span>
                                </div>
                            </div>
                        </div> */}

            <div className="swiper-container pickslide-number" style={{ width: "100%" }}>
              <div className="swiper-wrapper">
                <div className="swiper-slide">
                  <span>1</span>
                </div>
                <div className="swiper-slide">
                  <span>2</span>
                </div>
                <div className="swiper-slide">
                  <span>3</span>
                </div>
                <div className="swiper-slide">
                  <span>4</span>
                </div>
                <div className="swiper-slide">
                  <span>5</span>
                </div>
                <div className="swiper-slide">
                  <span>6</span>
                </div>
                <div className="swiper-slide">
                  <span>7</span>
                </div>
                <div className="swiper-slide">
                  <span>8</span>
                </div>
                <div className="swiper-slide">
                  <span>9</span>
                </div>
                <div className="swiper-slide">
                  <span>10</span>
                </div>
                <div className="swiper-slide">
                  <span>11</span>
                </div>
                <div className="swiper-slide">
                  <span>12</span>
                </div>
                <div className="swiper-slide">
                  <span>13</span>
                </div>
                <div className="swiper-slide">
                  <span>14</span>
                </div>
                <div className="swiper-slide">
                  <span>15</span>
                </div>
              </div>
            </div>
          </div>

          <div className="tbns-area">
            <a href={void 0} className="btn-round gray">
              취소
            </a>
            <a href={void 0} className="btn-round wht">
              확인
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

let onepickSlide;
let onepickInvalue;

export const pickerOnInsFn = () => {
  onepickSlide = new Swiper(".onepick-slide", {
    // Optional parameters
    direction: "vertical",
    loop: true,
    slidesPerView: 3,
    centeredSlides: true,
    on: {
      slideChangeTransitionEnd: function () {
        onepickInvalue = $(".onepick-slide .swiper-slide-active span").html();
      },
    },
  });
};

export const pickerOneEndInsFn = () => {
  onepickSlide.destroy();
};

export const openAlertPopup = (msg) => {
  $("#alertPopup").show();
  $("#msg").text(msg);
};

export const AlertPopup = (props) => {
  const { color, clickEvent } = props;
  const closePopup = () => {
    if (clickEvent) {
      _O.OpenMenu(clickEvent);
    } else {
      $("#alertPopup").hide();
    }
  };

  return (
    <div
      className="blacklayer-container"
      id="alertPopup"
      style={{ zIndex: "99999" }}>
      <div className="bl-blind"></div>
      <div className="in-layerarea">
        <div
          className={color ? "blgrn-box vertical priv" : "blgrn-box vertical"}>
          <div className="doctor-message">
            <div className="message-box" id="msg"></div>

            <div className="btn-area">
              <a className="btn-round wht" onClick={closePopup}>
                확인
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const InputPopup = (props) => {
  const { color, hpKey, hpName, handleConfirm, registToAttctNo, setAttctNo } = props;
  const { userinfo, cfg, phonecfg, dispatch } = useContext(AppContext);
  const closePopup = () => {
    closeLayerFn($("#inputPopup"));
    // 저장 이벤트 추가
  };

  const applyPtntNo = () => {
    if (hpKey) {
      if ($("#ptntNo").val() != "") {
        request1914(
          userinfo,
          cfg,
          phonecfg,
          dispatch,
          "hpKey",
          "Y",
          hpKey,
          $("#ptntNo").val(),
          handleConfirm
        );
        $("#ptntNo").val("");
        closeLayerFn($("#inputPopup"));
      } else {
        handleConfirm("", "인증번호를 입력하세요.");
      }
    } else {
      if ($("#ptntNo").val() != "") {
        setAttctNo($("#ptntNo").val());
        registToAttctNo($("#ptntNo").val());
      } else {
        openAlertPopup("인증번호를 입력하세요.");
      }
    }
  };

  useEffect(() => {
    $("#ptntNoYn").toggle(
      function () {
        $("#ptntNo").attr("disabled", true);
      },
      function () {
        $("#ptntNo").removeAttr("disabled");
      }
    );
  }, []);

  return (
    <div className="blacklayer-container" id="inputPopup" style={{ zIndex: "50" }}>
      <div className="bl-blind"></div>
      <div className="in-layerarea">
        {/* <div className="blgrn-box vertical"> */}
        <div className={color ? "blgrn-box vertical priv" : "blgrn-box vertical"}>
          <div className="blgr-title">{hpName}</div>
          <div className="doctor-message">
            <div className="message-box" id="msg">
              인증번호:
              <input
                type="text"
                id="ptntNo"
                style={{ border: "1px", marginLeft: "10px" }}
                maxLength="20"
              />
            </div>

            {/* 환자번호 관련 추가설명 */}
            <div className="message-box" style={{ fontSize: "13px" }}>
              ※병원에서 안내받은 인증번호를 입력하세요. <br />
              <span id="msgDtl"></span>
            </div>

            <div className="btn-area">
              <a className="btn-round gray" onClick={() => closeLayerFn($("#inputPopup"))}>
                닫기
              </a>
              <a className="btn-round wht" onClick={applyPtntNo}>
                등록
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const DetailPopup = (props) => {
  const { color, resultList } = props;
  const closePopup = () => {
    $("#detailPopup").hide();
  };

  return (
    <div className="blacklayer-container" id="detailPopup" style={{ zIndex: "50" }}>
      <div className="bl-blind"></div>
      <div className="in-layerarea">
        {/* <div className="blgrn-box vertical"> */}
        <div className={color ? "blgrn-box vertical priv" : "blgrn-box vertical"}>
          <div className="doctor-message">
            <div className="message-box" id="msg">
              <ul style={{ textAlign: "left" }}>
                {resultList && resultList[0].medicineId ? (
                  <Fragment>
                    <li>
                      <strong>약품명 : </strong>
                      <span id="title"></span>
                    </li>
                    <li style={{ paddingTop: "10px" }}>
                      <strong>조제사 : </strong>
                      <span id="subTitle">{resultList[0].Producer}</span>
                    </li>
                    <li style={{ paddingTop: "10px" }}>
                      <strong>성분정보 : </strong>
                      <div style={{ overflow: "auto", maxHeight: "20rem" }}>
                        <p id="ingredientName">{resultList[0].IngredientName}</p>
                      </div>
                    </li>
                  </Fragment>
                ) : (
                  <Fragment>
                    <li>
                      <strong>약품명 : </strong>
                      <span id="title"></span>
                    </li>
                    <li style={{ paddingTop: "10px" }}>
                      <strong>성분정보 : </strong>
                      <div style={{ overflow: "auto", maxHeight: "20rem" }}>
                        <p id="ingredientName"></p>
                        {resultList &&
                          resultList.map((m, i) => <p key={"ingredient" + i}>{m.Ingredient}</p>)}
                      </div>
                    </li>
                  </Fragment>
                )}
              </ul>
            </div>

            <div className="btn-area">
              <a className="btn-round wht" onClick={closePopup}>
                확인
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const PeriodSetting = memo((props) => {
  const { settingPeriodType, periodType, startDate, endDate } = props;

  useEffect(() => {
    // $(".date-setting-area .btns a").click(function () {
    //   $(".date-setting-area .btns a").removeClass("on");
    //   $(this).addClass("on");
    //   var idx = $(this).index();
    //   if (idx == 3) {
    //     //직접 기간설정
    //     $(".date-setting-area .date-input").slideDown("fast");
    //   } else {
    //     $(".date-setting-area .date-input").slideUp("fast");
    //   }
    // });

    if (periodType == 4) {
      $(".pick-num1").val(
        startDate.substring(0, 4) +
          "." +
          startDate.substring(4, 6) +
          "." +
          startDate.substring(6, 8)
      );

      $(".pick-num2").val(
        endDate.substring(0, 4) + "." + endDate.substring(4, 6) + "." + endDate.substring(6, 8)
      );
    }
  }, []);

  return (
    <Fragment>
      <div className="btns">
        <a
          onClick={() => settingPeriodType(1)}
          className={periodType == 1 ? "on" : ""}>
          1주일
        </a>
        <a
          onClick={() => settingPeriodType(2)}
          className={periodType == 2 ? "on" : ""}>
          1개월
        </a>
        <a
          onClick={() => settingPeriodType(3)}
          className={periodType == 3 ? "on" : ""}>
          3개월
        </a>
        <a
          onClick={() => settingPeriodType(4)}
          // className={periodType == 4 ? "btn-selfinput on" : "btn-selfinput"}
          className={`btn-selfinput ${periodType == 4 ? "on": ""}`}>
          기간설정
        </a>
      </div>
      <div className="date-input">
        <div className="round-bar">
          <div className="ipbox">
            <input
              type="text"
              placeholder="선택하세요."
              readOnly
              className="date-picker-input pick-num1"
              data-num="1"
            />
            <i></i>
          </div>
          <u>~</u>
          <div className="ipbox">
            <input
              type="text"
              placeholder="선택하세요."
              readOnly
              className="date-picker-input pick-num2"
              data-num="2"
            />
            <i></i>
          </div>
        </div>
      </div>
    </Fragment>
  );
});

export const NoData = ({ children }) => {
  return (
    <div className="nothing-box">
      <div>
        <img src={IC.empty.eocsIng} alt="" />
        <p>
          {children}
          <br />
        </p>
      </div>
    </div>
  );
};